/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
export type StartExportUsersJson200 = {
  bucket: string;
  downloadUrl: string;
  filename: string;
  key: string;
  started: boolean;
};

export type GetExportUsersJsonStatus200 = {
  bucket: string;
  downloadUrl?: string;
  key: string;
  ready: boolean;
};

export type GetExportUsersJsonStatusParams = {
  bucket?: string;
  key: string;
};

export type StartExportUsersCsv200 = {
  bucket: string;
  downloadUrl: string;
  filename: string;
  key: string;
  started: boolean;
};

export type GetExportUsersCsvStatus200 = {
  bucket: string;
  downloadUrl?: string;
  key: string;
  ready: boolean;
};

export type GetExportUsersCsvStatusParams = {
  bucket?: string;
  key: string;
};

export type GetUserPoolUsersParams = {
  limit?: number;
  nextToken?: string;
  searchEmail?: string;
};

export type ArchiveArticle200 = {
  message: string;
};

/**
 * @nullable
 */
export type GetAdminArticleByFixture200 = ArticleItem | null;

export type GetGenerationStatusParams = {
  executionArn: string;
};

export type GenerateArticle202 = {
  executionArn?: string;
  message: string;
};

/**
 * @nullable
 */
export type GetArticleByFixture200 = ArticleItem | null;

/**
 * @nullable
 */
export type GetArticleBySlug200 = ArticleItem | null;

export type GetArticlesParams = {
  page?: number;
  limit?: number;
  league_id?: number;
  status?: ArticleStatus;
  date_from?: string;
  date_to?: string;
};

export type ClearAuthCaches200 = {
  message: string;
  timestamp: string;
};

export type ResetAuthMetrics200 = {
  message: string;
  timestamp: string;
};

export type GetAuthMetrics200Performance = {
  averageAuthTimeMs: number;
  partnerCacheHitRate: number;
  totalRequests: number;
  verifierCacheHitRate: number;
};

export type GetAuthMetrics200 = {
  cacheMetrics: GetAuthMetrics200CacheMetrics;
  performance: GetAuthMetrics200Performance;
  rawMetrics: AuthMetrics;
};

export type GetAuthMetrics200CacheMetricsVerifier = {
  hits: number;
  maxSize: number;
  misses: number;
  size: number;
};

export type GetAuthMetrics200CacheMetricsPartner = {
  hits: number;
  maxSize: number;
  misses: number;
  size: number;
};

export type GetAuthMetrics200CacheMetrics = {
  partner: GetAuthMetrics200CacheMetricsPartner;
  verifier: GetAuthMetrics200CacheMetricsVerifier;
};

export type GetBestFilterParams = {
  from?: string;
  to?: string;
};

export type GetDailyTopPicksSummaryParams = {
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  fixture_ids?: string[];
  min_odds?: number;
  max_odds?: number;
  season?: number;
  min_probability?: number;
  max_probability?: number;
  min_edge?: number;
  max_edge?: number;
  min_stake?: number;
  max_stake?: number;
  include_ratings?: Ratings[];
  include_categories?: Category[];
  include_tip_status?: TipStatus[];
  include_leagues?: number[];
  best_choice?: boolean;
  from?: string;
  to?: string;
  sortOrder?: SortOrder;
  page?: number;
  pageSize?: number;
  sortBy?: DailyTopPicksSortField;
  include_ranks?: number[];
  include_types?: DailyTopPickType[];
};

export type GetDailyTopPicksParams = {
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  fixture_ids?: string[];
  min_odds?: number;
  max_odds?: number;
  season?: number;
  min_probability?: number;
  max_probability?: number;
  min_edge?: number;
  max_edge?: number;
  min_stake?: number;
  max_stake?: number;
  include_ratings?: Ratings[];
  include_categories?: Category[];
  include_tip_status?: TipStatus[];
  include_leagues?: number[];
  best_choice?: boolean;
  from?: string;
  to?: string;
  sortOrder?: SortOrder;
  page?: number;
  pageSize?: number;
  sortBy?: DailyTopPicksSortField;
  include_ranks?: number[];
  include_types?: DailyTopPickType[];
};

export type EmailOptInStatus200 = {
  show: boolean;
};

export type GetFixturesParams = {
  from: string;
  to: string;
};

export type SearchLeaguesParams = {
  q: string;
};

export type GetModelRaceStatsParams = {
  fixtureId?: string;
};

export type GetModelRaceResultsParams = {
  fixtureId?: string;
  limit?: number;
  lastEvaluatedKey?: string;
};

/**
 * @nullable
 */
export type GetStatistics200 = StatisticsResponse | null;

/**
 * @nullable
 */
export type GetTipById200 = Tip | null;

export type GetTipByIdGroupBy =
  (typeof GetTipByIdGroupBy)[keyof typeof GetTipByIdGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipByIdGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type GetTipByIdParams = {
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  type: TipType;
  sortOrder?: SortOrder;
  sortBy?: SortField;
  to?: string;
  from?: string;
  best_choice?: boolean;
  include_leagues?: number[];
  include_tip_status?: TipStatus[];
  include_categories?: Category[];
  include_ratings?: Ratings[];
  max_stake?: number;
  min_stake?: number;
  max_edge?: number;
  min_edge?: number;
  max_probability?: number;
  min_probability?: number;
  season?: number;
  max_odds?: number;
  min_odds?: number;
  fixture_ids?: string[];
  page?: number;
  pageSize?: number;
  include_match_status?: MatchStatus[];
  groupBy?: GetTipByIdGroupBy;
};

export type GetTipsByFixtureGroupBy =
  (typeof GetTipsByFixtureGroupBy)[keyof typeof GetTipsByFixtureGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipsByFixtureGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type GetTipsByFixtureParams = {
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  type: TipType;
  sortOrder?: SortOrder;
  sortBy?: SortField;
  to?: string;
  from?: string;
  best_choice?: boolean;
  include_leagues?: number[];
  include_tip_status?: TipStatus[];
  include_categories?: Category[];
  include_ratings?: Ratings[];
  max_stake?: number;
  min_stake?: number;
  max_edge?: number;
  min_edge?: number;
  max_probability?: number;
  min_probability?: number;
  season?: number;
  max_odds?: number;
  min_odds?: number;
  fixture_ids?: string[];
  page?: number;
  pageSize?: number;
  include_match_status?: MatchStatus[];
  groupBy?: GetTipsByFixtureGroupBy;
};

export type InitialFiltersGetParams = {
  from?: string;
  to?: string;
  type: TipType;
};

export type GetUpcomingTipCountsParams = {
  type: TipType;
  /**
   * Start instant, ISO-8601, inclusive.
   */
  from: string;
  /**
   * End instant, ISO-8601, exclusive. At most 168 hours after `from`.
   */
  to: string;
};

export type GetTipsDailyBreakdownParams = {
  type: TipType;
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  fixture_ids?: string[];
  min_odds?: number;
  max_odds?: number;
  season?: number;
  min_probability?: number;
  max_probability?: number;
  min_edge?: number;
  max_edge?: number;
  min_stake?: number;
  max_stake?: number;
  include_ratings?: Ratings[];
  include_categories?: Category[];
  include_leagues?: number[];
  best_choice?: boolean;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  /**
   * First Budapest calendar day, YYYY-MM-DD.
   */
  from: string;
  /**
   * Last Budapest calendar day, YYYY-MM-DD, inclusive. At most 62 days after `from`.
   */
  to: string;
};

export type GetTopPerformersParams = {
  from?: string;
  to?: string;
  type: TipType;
};

export type GetTipsSummaryParams = {
  type: TipType;
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  fixture_ids?: string[];
  min_odds?: number;
  max_odds?: number;
  season?: number;
  min_probability?: number;
  max_probability?: number;
  min_edge?: number;
  max_edge?: number;
  min_stake?: number;
  max_stake?: number;
  include_ratings?: Ratings[];
  include_categories?: Category[];
  include_leagues?: number[];
  best_choice?: boolean;
  from?: string;
  to?: string;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  kellyFraction?: number;
  initialBankroll?: number;
};

export type GetUpcomingTips200 =
  | TipsWithFixtureResponse
  | IndividualTipsResponse;

export type GetUpcomingTipsGroupBy =
  (typeof GetUpcomingTipsGroupBy)[keyof typeof GetUpcomingTipsGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUpcomingTipsGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type GetUpcomingTipsParams = {
  type: TipType;
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  fixture_ids?: string[];
  min_odds?: number;
  max_odds?: number;
  season?: number;
  min_probability?: number;
  max_probability?: number;
  min_edge?: number;
  max_edge?: number;
  min_stake?: number;
  max_stake?: number;
  include_ratings?: Ratings[];
  include_categories?: Category[];
  include_leagues?: number[];
  best_choice?: boolean;
  from?: string;
  to?: string;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  page?: number;
  pageSize?: number;
  groupBy?: GetUpcomingTipsGroupBy;
};

export type GetTipsPerformance200 =
  | TipsWithFixtureResponse
  | IndividualTipsResponse;

export type GetTipsPerformanceGroupBy =
  (typeof GetTipsPerformanceGroupBy)[keyof typeof GetTipsPerformanceGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipsPerformanceGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type GetTipsPerformanceParams = {
  type: TipType;
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  fixture_ids?: string[];
  min_odds?: number;
  max_odds?: number;
  season?: number;
  min_probability?: number;
  max_probability?: number;
  min_edge?: number;
  max_edge?: number;
  min_stake?: number;
  max_stake?: number;
  include_ratings?: Ratings[];
  include_categories?: Category[];
  include_leagues?: number[];
  best_choice?: boolean;
  from?: string;
  to?: string;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  page?: number;
  pageSize?: number;
  groupBy?: GetTipsPerformanceGroupBy;
};

export type GetTips200 = TipsWithFixtureResponse | IndividualTipsResponse;

export type GetTipsGroupBy =
  (typeof GetTipsGroupBy)[keyof typeof GetTipsGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipsGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type GetTipsParams = {
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  type: TipType;
  sortOrder?: SortOrder;
  sortBy?: SortField;
  to?: string;
  from?: string;
  best_choice?: boolean;
  include_leagues?: number[];
  include_tip_status?: TipStatus[];
  include_categories?: Category[];
  include_ratings?: Ratings[];
  max_stake?: number;
  min_stake?: number;
  max_edge?: number;
  min_edge?: number;
  max_probability?: number;
  min_probability?: number;
  season?: number;
  max_odds?: number;
  min_odds?: number;
  fixture_ids?: string[];
  page?: number;
  pageSize?: number;
  include_match_status?: MatchStatus[];
  groupBy?: GetTipsGroupBy;
};

export type WelcomeBody = {
  locale?: string;
  userId?: string;
};

export type DeleteUserTip200 = {
  id: string;
};

export type GetUserTipsSummaryGroupBy =
  (typeof GetUserTipsSummaryGroupBy)[keyof typeof GetUserTipsSummaryGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserTipsSummaryGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type GetUserTipsSummaryParams = {
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  fixture_ids?: string[];
  min_odds?: number;
  max_odds?: number;
  season?: number;
  min_probability?: number;
  max_probability?: number;
  min_edge?: number;
  max_edge?: number;
  min_stake?: number;
  max_stake?: number;
  include_ratings?: Ratings[];
  include_categories?: Category[];
  include_tip_status?: TipStatus[];
  include_leagues?: number[];
  best_choice?: boolean;
  from?: string;
  to?: string;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  type?: TipType;
  page?: number;
  pageSize?: number;
  groupBy?: GetUserTipsSummaryGroupBy;
};

export type GetUserTips200 =
  | UserTipsWithFixtureResponse
  | IndividualUserTipsResponse;

export type GetUserTipsGroupBy =
  (typeof GetUserTipsGroupBy)[keyof typeof GetUserTipsGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserTipsGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type GetUserTipsParams = {
  safe_to_bet?: boolean;
  min_predictability?: number;
  max_predictability?: number;
  min_match_importance?: number;
  max_match_importance?: number;
  fixture_ids?: string[];
  min_odds?: number;
  max_odds?: number;
  season?: number;
  min_probability?: number;
  max_probability?: number;
  min_edge?: number;
  max_edge?: number;
  min_stake?: number;
  max_stake?: number;
  include_ratings?: Ratings[];
  include_categories?: Category[];
  include_tip_status?: TipStatus[];
  include_leagues?: number[];
  best_choice?: boolean;
  from?: string;
  to?: string;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  type?: TipType;
  page?: number;
  pageSize?: number;
  groupBy?: GetUserTipsGroupBy;
};

export type AdminUserDetailsResponseSource = {
  ip_address?: string;
  referrer?: string;
  signupTracked?: string;
  source?: string;
  utm_source?: string;
};

export type AdminUserDetailsResponsePreferences = {
  bankroll?: number;
  currency?: string;
  kellyFraction?: number;
};

export type AdminUserDetailsResponsePersonalInformation = {
  age?: string;
  country?: string;
  email?: string;
  email_verified?: string;
  family_name?: string;
  gender?: string;
  given_name?: string;
  identities?: string;
  locale?: string;
  name?: string;
  sub?: string;
};

export type AdminUserDetailsResponseCommunication = {
  dismissedTelegramPermanently?: boolean;
  feedbackSurvey?: string;
  marketingEmails?: string;
  newsLetters?: string;
  platformUpdates?: string;
  telegramDismissedAt?: number;
  telegramJoined?: boolean;
};

export interface AdminUserDetailsResponse {
  communication: AdminUserDetailsResponseCommunication;
  personalInformation: AdminUserDetailsResponsePersonalInformation;
  preferences: AdminUserDetailsResponsePreferences;
  source: AdminUserDetailsResponseSource;
  strategies: Strategy[];
}

export interface GetUserPoolStatsResponse {
  emailSignups: number;
  socialSignups: number;
  subscribedUsers: number;
  totalUsers: number;
}

export interface GetUsersQueryParams {
  limit?: number;
  nextToken?: string;
  searchEmail?: string;
}

export type GetUserPoolUsersResponsePagination = {
  limit: number;
  nextToken?: string;
};

export interface UserPoolUser {
  /** @nullable */
  age: number | null;
  /** @nullable */
  country: string | null;
  created: string;
  email: string;
  email_verified: boolean;
  /** @nullable */
  family_name: string | null;
  /** @nullable */
  feedbackSurvey: string | null;
  /** @nullable */
  gender: string | null;
  /** @nullable */
  given_name: string | null;
  /** @nullable */
  identities: string | null;
  /** @nullable */
  locale: string | null;
  /** @nullable */
  marketingEmails: string | null;
  /** @nullable */
  name: string | null;
  /** @nullable */
  newsLetters: string | null;
  /** @nullable */
  platformUpdates: string | null;
  /** @nullable */
  signupTracked: string | null;
  status: boolean;
  /** @nullable */
  stripeCustomerUrl: string | null;
  /** @nullable */
  sub: string | null;
  subscribed: boolean;
  userId: string;
}

export interface GetUserPoolUsersResponse {
  pagination: GetUserPoolUsersResponsePagination;
  users: UserPoolUser[];
}

export type AdminMeResponseUser = {
  isAdmin: boolean;
  partnerId: string;
  userId: string;
};

export interface AdminMeResponse {
  partner: PickPartnerExcludeKeyofPartnerStripeSettings;
  user: AdminMeResponseUser;
}

export type PipelineStatusValue =
  (typeof PipelineStatusValue)[keyof typeof PipelineStatusValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PipelineStatusValue = {
  RUNNING: "RUNNING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  TIMED_OUT: "TIMED_OUT",
  ABORTED: "ABORTED",
  NOT_FOUND: "NOT_FOUND",
} as const;

export interface PipelineStatusResponse {
  cause?: string;
  completedAt?: string;
  error?: string;
  executionArn: string;
  fixtureId: number;
  status: PipelineStatusValue;
  triggeredAt: string;
}

export interface TriggerPipelineResponse {
  executionArn: string;
  executionName: string;
  fixtureId: number;
  triggeredAt: string;
}

export interface UpdateArticleBody {
  content_markdown?: string;
  description?: string;
  excerpt?: string;
  keywords?: string[];
  title?: string;
}

/**
 * @nullable
 */
export type ArticleGenerationStatusResponseArticle = ArticleItem | null;

export type ExecutionStatusValue =
  (typeof ExecutionStatusValue)[keyof typeof ExecutionStatusValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExecutionStatusValue = {
  RUNNING: "RUNNING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  TIMED_OUT: "TIMED_OUT",
  ABORTED: "ABORTED",
  PENDING_REDRIVE: "PENDING_REDRIVE",
  NOT_FOUND: "NOT_FOUND",
} as const;

export type ArticleGenerationStatusResponseExecution = {
  cause?: string;
  error?: string;
  startDate?: string;
  status: ExecutionStatusValue;
  stopDate?: string;
};

export interface ArticleGenerationStatusResponse {
  /** @nullable */
  article: ArticleGenerationStatusResponseArticle;
  execution: ArticleGenerationStatusResponseExecution;
  fixtureId: string;
}

export interface ArticlesListResponse {
  articles: ArticleItem[];
  limit: number;
  page: number;
  total: number;
}

/**
 * Article data model for DynamoDB storage
Table: Articles-{stage}
PK: fixture_id (S), SK: version (N)
 */
export type ArticleStatus = (typeof ArticleStatus)[keyof typeof ArticleStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleStatus = {
  generating: "generating",
  draft: "draft",
  published: "published",
  archived: "archived",
  failed: "failed",
} as const;

export interface ListArticlesQueryParams {
  date_from?: string;
  date_to?: string;
  league_id?: number;
  limit?: number;
  page?: number;
  status?: ArticleStatus;
}

export type ImagePlacement =
  (typeof ImagePlacement)[keyof typeof ImagePlacement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImagePlacement = {
  hero: "hero",
  team_news: "team_news",
  tactical: "tactical",
  statistics: "statistics",
  inline: "inline",
} as const;

export interface ArticleImage {
  alt: string;
  caption: string;
  credit: string;
  placement: ImagePlacement;
  s3_key: string;
  url: string;
}

export interface ArticleItem {
  away_team: string;
  canonical_url: string;
  content_markdown: string;
  created_at: string;
  description: string;
  excerpt: string;
  fact_check_passed: boolean;
  fixture_id: string;
  generation_cost_usd: number;
  generation_duration_ms: number;
  generation_model: string;
  home_team: string;
  id: string;
  images: ArticleImage[];
  keywords: string[];
  league_id: number;
  league_name: string;
  match_date: string;
  og_image_url: string;
  /** @nullable */
  published_at: string | null;
  quality_score: number;
  /** @nullable */
  reviewed_by: string | null;
  schema_json_ld: string;
  slug: string;
  source_data_hash: string;
  status: ArticleStatus;
  title: string;
  updated_at: string;
  venue: string;
  verification_notes: string[];
  version: number;
}

export interface AuthMetrics {
  allPartnersCacheHits: number;
  allPartnersCacheMisses: number;
  averageAuthTime: number;
  partnerCacheHits: number;
  partnerCacheMisses: number;
  requestCount: number;
  userAttributesCacheHits: number;
  userAttributesCacheMisses: number;
  verifierCacheHits: number;
  verifierCacheMisses: number;
}

export interface ContactBody {
  email: string;
  message: string;
  name: string;
  recaptchaToken: string;
  /** Honeypot: hidden from people, filled by bots. Any value rejects the submission. */
  website?: string;
}

export interface ContactResponse {
  email: string;
  message: string;
  name: string;
}

export interface GetBestDailyTopPicksFilterQueryParams {
  from?: string;
  to?: string;
}

export type BestDailyTopPicksFilterResponseBestFilter = {
  from: string;
  include_ranks: number[];
  include_types: DailyTopPickType[];
  to: string;
};

export interface BestDailyTopPicksFilterResponse {
  best_filter: BestDailyTopPicksFilterResponseBestFilter;
  evaluated_combinations: number;
  performance: DailyTopPicksPerformanceResponse;
}

export type DailyTopPicksPerformanceResponseBankrollOverTime = {
  default: BankrollStrategySummaryRecord;
  flat_betting: BankrollStrategySummaryRecord;
  kelly_criterion: BankrollStrategySummaryRecord;
};

export interface DailyTopPicksPerformanceResponse {
  avg_bet_amount: number;
  avg_odds: number;
  avg_probability: number;
  bankrollOverTime: DailyTopPicksPerformanceResponseBankrollOverTime;
  brier_score: number;
  hit_rate: number;
  profit_loss: number;
  roi: number;
  total_lost: number;
  total_matches: number;
  total_push: number;
  total_staked: number;
  total_tips: number;
  total_unsettled: number;
  total_won: number;
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickGetTipsQueryParamsExcludeKeyofGetTipsQueryParamsTypeOrSortBy {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  include_tip_status?: TipStatus[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortOrder?: SortOrder;
  to?: string;
}

export type DailyTopPicksSortField =
  (typeof DailyTopPicksSortField)[keyof typeof DailyTopPicksSortField];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DailyTopPicksSortField = {
  date: "date",
  category: "category",
  probability: "probability",
  odds: "odds",
  stake: "stake",
  edge: "edge",
  rank: "rank",
} as const;

export type DailyTopPicksResponseMeta = {
  total: number;
  total_safe: number;
  total_value: number;
};

export interface DailyTipWithFixture {
  fixture: FixtureItem;
  isLocked?: boolean;
  /** @nullable */
  tip: DailyTipWithFixtureTip;
}

export interface DailyTopPicksResponse {
  currentPage: number;
  data: DailyTipWithFixture[];
  meta: DailyTopPicksResponseMeta;
  totalItems: number;
  totalPages: number;
}

export type DailyTopPickType =
  (typeof DailyTopPickType)[keyof typeof DailyTopPickType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DailyTopPickType = {
  safe: "safe",
  value: "value",
} as const;

export interface GetDailyTopPicksQueryParams {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ranks?: number[];
  include_ratings?: Ratings[];
  include_tip_status?: TipStatus[];
  include_types?: DailyTopPickType[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  page?: number;
  pageSize?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: DailyTopPicksSortField;
  sortOrder?: SortOrder;
  to?: string;
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickDailyTopPickRecordExcludeKeyofDailyTopPickRecordReasoning {
  fixture_id: string;
  id: string;
  league_id: number;
  rank: number;
  season: number;
  start_date: string;
  type: DailyTopPickType;
  winner?: boolean;
}

export type DailyTopPick =
  PickDailyTopPickRecordExcludeKeyofDailyTopPickRecordReasoning & Tip;

/**
 * @nullable
 */
export type DailyTipWithFixtureTip = DailyTopPick | null;

/**
 * Construct a type with the properties of T except for those in type K.
 */
export type OmitDailyTopPickRecordReasoning =
  PickDailyTopPickRecordExcludeKeyofDailyTopPickRecordReasoning;

export type OptInRequestSurface =
  (typeof OptInRequestSurface)[keyof typeof OptInRequestSurface];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OptInRequestSurface = {
  unlock: "unlock",
  save: "save",
} as const;

export type OptInRequestAnswer =
  (typeof OptInRequestAnswer)[keyof typeof OptInRequestAnswer];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OptInRequestAnswer = {
  yes: "yes",
  no: "no",
} as const;

export interface OptInRequest {
  answer: OptInRequestAnswer;
  copyVersion: string;
  locale?: string;
  surface: OptInRequestSurface;
}

/**
 */
export type EngagementSignalType =
  (typeof EngagementSignalType)[keyof typeof EngagementSignalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EngagementSignalType = {
  match_dwell: "match_dwell",
} as const;

export type EngagementSignalPresentation =
  (typeof EngagementSignalPresentation)[keyof typeof EngagementSignalPresentation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EngagementSignalPresentation = {
  inline: "inline",
  dialog: "dialog",
} as const;

export type EngagementSignalActed =
  (typeof EngagementSignalActed)[keyof typeof EngagementSignalActed];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EngagementSignalActed = {
  none: "none",
  unlocked: "unlocked",
  saved: "saved",
} as const;

/**
 * Dashboard engagement signals (user-retention step 09). Sent only with the
user's analytics consent; the consent-independent signal is step 07's
last-seen write.
 */
export interface EngagementSignal {
  acted: EngagementSignalActed;
  /** Visible, in-viewport time on the match; clamped to 30 min. */
  dwellMs: number;
  fixtureId: number;
  presentation: EngagementSignalPresentation;
  /** */
  type: EngagementSignalType;
}

export interface EmailLandingBody {
  /** The signed send reference from the email link's `rs` parameter. */
  rs: string;
}

export interface CreateExpertOpinionFromUrlBody {
  fixtureId: string;
  url: string;
}

export interface CreateExpertOpinionFromUrlResponse {
  success: boolean;
}

export interface ExpertOpinion {
  content: string;
  id: string;
  prompt: string;
  /** @nullable */
  score: string | null;
  /** @nullable */
  url: string | null;
}

export interface GetFixturesQueryParams {
  from: string;
  to: string;
}

export type FixtureRecordAllOfLeagueId = string | number;

export type FixtureRecordAllOfId = string | number;

export type FixtureRecordAllOf = {
  awayTeamId: number;
  date: string;
  homeTeamId: number;
  id: FixtureRecordAllOfId;
  lastFetchedAt: number;
  leagueId: FixtureRecordAllOfLeagueId;
};

export type FixtureRecord = FixtureItem & FixtureRecordAllOf;

export interface BetValue {
  odd: string;
  value: string;
}

export interface BetItem {
  id: number;
  name: string;
  values: BetValue[];
}

export interface FreeAnalysisBalanceResponse {
  can_unlock: boolean;
  max_free_analysis: number;
  next_unlock_date: string;
  unlocked_analysis: number;
}

export type UnlockFailReason =
  (typeof UnlockFailReason)[keyof typeof UnlockFailReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnlockFailReason = {
  error: "error",
  max_analysis: "max_analysis",
  already_unlocked: "already_unlocked",
  ip_limit: "ip_limit",
  success: "success",
} as const;

export interface UnlockMatchResponse {
  message: string;
  reason: UnlockFailReason;
  success: boolean;
}

export type MatchAnalysisItemTeamComparison = {
  away_team: MatchAnalysisTeamStats;
  home_team: MatchAnalysisTeamStats;
  reasoning: string;
};

export type MatchAnalysisItemSummary = {
  match_importance: number;
  predictability: number;
  safe_for_betting: boolean;
};

export interface MatchAnalysisItem {
  correct_score: string;
  correct_score_reasoning: string;
  id: string;
  match_preview: string;
  prompt: string;
  recommendations: MatchAnalysisItemRecommendations;
  summary: MatchAnalysisItemSummary;
  team_comparison: MatchAnalysisItemTeamComparison;
}

export type MatchAnalysisItemRecommendationsThingsToAvoidItem = {
  short_reasoning: string;
  title: string;
};

export type MatchAnalysisItemRecommendationsBettingRecommendationsItem = {
  short_reasoning: string;
  title: string;
};

export type MatchAnalysisItemRecommendations = {
  betting_recommendations: MatchAnalysisItemRecommendationsBettingRecommendationsItem[];
  things_to_avoid: MatchAnalysisItemRecommendationsThingsToAvoidItem[];
};

export interface MatchAnalysisTeamStats {
  injury_impact: number;
  motivations: number;
  recent_form: number;
  tactical_advantage: number;
  team_health_index: number;
}

export interface GetModelRaceStatsQueryParams {
  fixtureId?: string;
}

export interface ModelRaceStats {
  avg_odds: number;
  hit_rate: number;
  key: string;
  profit_loss: number;
  roi: number;
  total_lost: number;
  total_push: number;
  total_recommendations: number;
  total_settled: number;
  total_staked: number;
  total_unsettled: number;
  total_won: number;
}

export interface ModelRaceStatsResponse {
  by_fixture: ModelRaceStats[];
  by_provider: ModelRaceStats[];
  overall: ModelRaceStats;
}

export interface DeleteModelRaceResultsByFixtureResponse {
  deletedCount: number;
}

export interface GetModelRaceResultsQueryParams {
  fixtureId?: string;
  lastEvaluatedKey?: string;
  limit?: number;
}

export interface ParsedRecommendation {
  /** @nullable */
  bookmaker_odds: number | null;
  confidence: string;
  market: string;
  /** @nullable */
  minimum_fair_odds: number | null;
  model: string;
  model_probability: number;
  reasoning: string;
  recommended_stake: number;
  selection: string;
  /** @nullable */
  value_edge: number | null;
  /** @nullable */
  winner?: boolean | null;
}

export interface UpdateModelRaceRecommendationsBody {
  recommendations: ParsedRecommendation[];
}

export interface ModelRaceItem {
  /** @nullable */
  cost_usd_estimated: number | null;
  created_at: string;
  duration_ms: number;
  fixture_id: string;
  id: string;
  /** @nullable */
  input_tokens: number | null;
  model_name: string;
  /** @nullable */
  output_tokens: number | null;
  /** @nullable */
  parse_error: string | null;
  parse_success: boolean;
  prompt_chars: number;
  provider: string;
  raw_response: string;
  recommendations: ParsedRecommendation[];
  recommendations_count: number;
  response_chars: number;
  /** @nullable */
  total_tokens: number | null;
}

export interface GetModelRaceResultsResponse {
  count: number;
  items: ModelRaceItem[];
  lastEvaluatedKey?: string;
}

export interface TutorialVideos {
  howToReadTips?: string;
}

export interface CompanyInfo {
  address: string;
  city: string;
  country: string;
  name: string;
  phone: string;
  postalCode: string;
  province: string;
  vatNumber: string;
}

export interface EmailTheme {
  background: string;
  bodyText: string;
  bodyTextSecondary: string;
  borderColor: string;
  linkColor: string;
  primaryBg: string;
  primaryText: string;
}

export interface PartnerContact {
  email: string;
  facebook?: string;
  feedbackLink?: string;
  instagram?: string;
  telegram?: string;
  tiktok?: string;
  whatsapp?: string;
}

export interface PartnerLogos {
  "16x16": string;
  "180x180": string;
  "32x32": string;
  horizontal: string;
  square: string;
}

export interface PartnerMeta {
  description: string;
  ogFacebook: string;
  ogTwitter: string;
  themeColor: string;
  title: string;
}

export interface CognitoSettings {
  cognitoDomain: string;
  identityPoolId: string;
  providers: string[];
  redirectSignIn: string[];
  redirectSignOut: string[];
  userPoolClientId: string;
  userPoolId: string;
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickPartnerExcludeKeyofPartnerStripeSettings {
  cognitoSettings: CognitoSettings;
  companyInfo: CompanyInfo;
  contact: PartnerContact;
  emailTheme: EmailTheme;
  frontendUrl: string;
  id: string;
  logo: PartnerLogos;
  maxUnlocks: number;
  meta: PartnerMeta;
  name: string;
  paymentOverdue?: boolean;
  theme: string;
  tutorialVideos?: TutorialVideos;
}

/**
 * Construct a type with the properties of T except for those in type K.
 */
export type OmitPartnerStripeSettings =
  PickPartnerExcludeKeyofPartnerStripeSettings;

/**
 * Engagement events forwarded by the "Retention events — <type>" workflows
(user-retention step 18), one workflow per trigger. Every field is a
`{{…}}` interpolation, so any of them may arrive empty — or, if this Plunk
build does not render a token, as the literal `{{…}}` text.
 */
export type PlunkEmailEventType =
  (typeof PlunkEmailEventType)[keyof typeof PlunkEmailEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlunkEmailEventType = {
  emailsent: "email.sent",
  emaildelivery: "email.delivery",
  emailopen: "email.open",
  emailclick: "email.click",
  emailbounce: "email.bounce",
  emailcomplaint: "email.complaint",
} as const;

export interface PlunkEmailEventBody {
  /** When the event happened, in whatever format Plunk renders a date. */
  at?: string;
  bounceType?: string;
  cognitoSub?: string;
  contactId?: string;
  emailId?: string;
  /** Click events only. */
  link?: string;
  messageId?: string;
  templateId?: string;
  type: PlunkEmailEventType;
}

/**
 * Present only when Plunk unsubscribed the contact automatically.
 */
export type PlunkWebhookBodyReason = string | "bounce" | "complaint";

/**
 * Reserved contact events emitted by Plunk, forwarded to us by a workflow.

Only `contact.unsubscribed` is acted on. Plunk raises these events for any
change to `subscribed` — including the ones our own sync makes — so acting
on `contact.subscribed` would let an echo of a CONSENT push overwrite the
preferences the user just saved.
 */
export type PlunkContactEventType =
  (typeof PlunkContactEventType)[keyof typeof PlunkContactEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlunkContactEventType = {
  contactsubscribed: "contact.subscribed",
  contactunsubscribed: "contact.unsubscribed",
} as const;

export interface PlunkWebhookBody {
  cognito_sub?: string;
  /** Plunk contact id, so the list flags can be cleared without a lookup. */
  contact_id?: string;
  email?: string;
  /** Present only when Plunk unsubscribed the contact automatically. */
  reason?: PlunkWebhookBodyReason;
  type: PlunkContactEventType;
}

export interface PlunkWebhookResponse {
  outcome?: string;
  success: boolean;
}

export interface Settings {
  id: string;
  leagues: LeagueItem[];
}

export type LeagueSeasonYear = string | number;

export type LeagueSeasonCoverageFixtures = {
  events: boolean;
  lineups: boolean;
  statistics_fixtures: boolean;
  statistics_players: boolean;
};

export type LeagueSeasonCoverage = {
  fixtures: LeagueSeasonCoverageFixtures;
  injuries: boolean;
  odds: boolean;
  players: boolean;
  predictions: boolean;
  standings: boolean;
  top_assists: boolean;
  top_cards: boolean;
  top_scorers: boolean;
};

export interface LeagueSeason {
  coverage: LeagueSeasonCoverage;
  current: boolean;
  end: string;
  start: string;
  year: LeagueSeasonYear;
}

export interface Country {
  /** @nullable */
  code: string | null;
  /** @nullable */
  flag: string | null;
  name: string;
}

export interface LeagueItem {
  country: Country;
  league: League;
  seasons: LeagueSeason[];
}

export type StatisticsResponseHomeTeam = {
  id: number;
  name: string;
};

export type StatisticsResponseDataQuality = {
  away: DataQualityMetrics;
  home: DataQualityMetrics;
};

export type StatisticsResponseAwayTeam = {
  id: number;
  name: string;
};

export interface StatisticsResponse {
  awayGames: GameRecord[];
  awayTeam: StatisticsResponseAwayTeam;
  dataQuality: StatisticsResponseDataQuality;
  homeGames: GameRecord[];
  homeTeam: StatisticsResponseHomeTeam;
  prompt: string;
}

export type DataQualityMetricsQualityIndicator =
  (typeof DataQualityMetricsQualityIndicator)[keyof typeof DataQualityMetricsQualityIndicator];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataQualityMetricsQualityIndicator = {
  excellent: "excellent",
  good: "good",
  poor: "poor",
} as const;

export interface DataQualityMetrics {
  availableStatCategories: string[];
  dataCompletenessPercentage: number;
  missingStatCategories: string[];
  qualityIndicator: DataQualityMetricsQualityIndicator;
  totalGamesFetched: number;
  validGamesCount: number;
}

export interface GameRecord {
  fixture: unknown;
  goals: unknown;
  league: unknown;
  score: unknown;
  statistics: GameStatistics;
  teams: unknown;
}

/**
 * Construct a type with a set of properties K of type T
 */
export interface RecordStringAny {
  [key: string]: unknown;
}

export interface StatsBreakdown {
  firstHalf: RecordStringAny;
  full: RecordStringAny;
  secondHalf: RecordStringAny;
}

export interface GameStatistics {
  opponent: StatsBreakdown;
  team: StatsBreakdown;
  total: StatsBreakdown;
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickStrategyExcludeKeyofStrategyUserIdOrCreatedAtOrUpdatedAt {
  filters: StrategyFilter[];
  id: string;
  name: string;
}

export interface CreateStrategyResponse {
  created_at: string;
  filters: StrategyFilter[];
  id: string;
  name: string;
  updated_at: string;
  user_id: string;
}

export type StrategyFilterTypes =
  (typeof StrategyFilterTypes)[keyof typeof StrategyFilterTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StrategyFilterTypes = {
  ratings: "ratings",
  leagues: "leagues",
  categories: "categories",
  odds: "odds",
  edge: "edge",
  stake: "stake",
  probability: "probability",
  predictability: "predictability",
  best_choice: "best_choice",
  safe_to_bet: "safe_to_bet",
  match_importance: "match_importance",
} as const;

export type StrategyFilterAllOf = {
  id: StrategyFilterTypes;
};

export type StrategyFilterValue =
  | SwitchFilterValue
  | RangeFilterValue
  | MultiSelectFilterValue;

export type StrategyFilter = StrategyFilterValue & StrategyFilterAllOf;

export interface Strategy {
  created_at: string;
  filters: StrategyFilter[];
  id: string;
  name: string;
  updated_at: string;
  user_id: string;
}

export interface UpdateStrategyBody {
  filters: StrategyFilter[];
  id: string;
  name: string;
}

export interface UpdateStrategyResponse {
  created_at: string;
  filters: StrategyFilter[];
  id: string;
  name: string;
  updated_at: string;
  user_id: string;
}

export interface CreateStrategyBody {
  filters: StrategyFilter[];
  name: string;
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickStrategyExcludeKeyofStrategyIdOrUserIdOrCreatedAtOrUpdatedAt {
  filters: StrategyFilter[];
  name: string;
}

export type MultiSelectFilterValueValueItem = string | number;

export type MultiSelectFilterValueType =
  (typeof MultiSelectFilterValueType)[keyof typeof MultiSelectFilterValueType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MultiSelectFilterValueType = {
  "multi-select-colored": "multi-select-colored",
  "multi-select-image": "multi-select-image",
  "multi-select": "multi-select",
} as const;

export interface MultiSelectFilterValue {
  type: MultiSelectFilterValueType;
  value: MultiSelectFilterValueValueItem[];
}

export type RangeFilterValueValue = {
  /** @nullable */
  max: number | null;
  /** @nullable */
  min: number | null;
};

/**
 */
export type RangeFilterValueType =
  (typeof RangeFilterValueType)[keyof typeof RangeFilterValueType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RangeFilterValueType = {
  range: "range",
} as const;

export interface RangeFilterValue {
  /** */
  type: RangeFilterValueType;
  value: RangeFilterValueValue;
}

/**
 */
export type SwitchFilterValueType =
  (typeof SwitchFilterValueType)[keyof typeof SwitchFilterValueType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SwitchFilterValueType = {
  switch: "switch",
} as const;

export interface SwitchFilterValue {
  /** */
  type: SwitchFilterValueType;
  value: boolean;
}

export interface Subscription {
  active_subscription: boolean;
  /** @nullable */
  cancels_at_date: string | null;
  currency: string;
  id: string;
  interval: string;
  payment_link: string;
  price: number;
}

export interface GetSubscriptionsResponse {
  has_active_subscription: boolean;
  manage_subscription_link: string;
  renew_subscription_link: string;
  subscriptions: Subscription[];
  trial_period_days?: number;
  update_subscription_link: string;
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt {
  alias: string;
  id: string;
  team_name: string;
}

export type UpdateTeamNameAliasBody =
  PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt;

/**
 * Construct a type with the properties of T except for those in type K.
 */
export type OmitTeamNameAliasCreatedAtOrUpdatedAt =
  PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt;

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt {
  alias: string;
  team_name: string;
}

export type CreateTeamNameAliasBody =
  PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt;

/**
 * Construct a type with the properties of T except for those in type K.
 */
export type OmitTeamNameAliasIdOrCreatedAtOrUpdatedAt =
  PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt;

export interface TeamNameAlias {
  alias: string;
  created_at: string;
  id: string;
  team_name: string;
  updated_at: string;
}

/**
 * @nullable
 */
export type TeamStatisticsResponseLeagueStandings = LeagueStandings | null;

export interface TeamStatisticsResponse {
  fixture: TeamStatisticsResponseFixture;
  /** @nullable */
  form: TeamStatisticsResponseForm;
  /** @nullable */
  keyMetrics: TeamStatisticsResponseKeyMetrics;
  /** @nullable */
  leagueStandings: TeamStatisticsResponseLeagueStandings;
}

export type TeamStatisticsResponseKeyMetricsHome = {
  h2h?: TeamStatisticsData;
  played_home?: TeamStatisticsData;
  total: TeamStatisticsData;
};

export type TeamStatisticsResponseKeyMetricsAway = {
  h2h?: TeamStatisticsData;
  played_away?: TeamStatisticsData;
  total: TeamStatisticsData;
};

/**
 * @nullable
 */
export type TeamStatisticsResponseKeyMetrics = {
  away: TeamStatisticsResponseKeyMetricsAway;
  home: TeamStatisticsResponseKeyMetricsHome;
} | null;

export type TeamStatisticsResponseFixtureLeague = {
  id: number;
  name: string;
  season: number;
};

export type TeamStatisticsResponseFixtureHomeTeam = {
  id: number;
  logo: string;
  name: string;
};

export type TeamStatisticsResponseFixtureAwayTeam = {
  id: number;
  logo: string;
  name: string;
};

export type TeamStatisticsResponseFixture = {
  awayTeam: TeamStatisticsResponseFixtureAwayTeam;
  homeTeam: TeamStatisticsResponseFixtureHomeTeam;
  id: string;
  league: TeamStatisticsResponseFixtureLeague;
};

export interface LeagueStandings {
  league: LeagueStandingsLeague;
  standings: LeagueStandingsStandingsItem[];
}

export type LeagueStandingsStandingsItemTeam = {
  id: number;
  logo: string;
  name: string;
};

export type LeagueStandingsStandingsItemHome = {
  draw: number;
  goalsAgainst: number;
  goalsFor: number;
  lose: number;
  played: number;
  win: number;
};

export type LeagueStandingsStandingsItemAway = {
  draw: number;
  goalsAgainst: number;
  goalsFor: number;
  lose: number;
  played: number;
  win: number;
};

export type LeagueStandingsStandingsItemAll = {
  draw: number;
  goalsAgainst: number;
  goalsFor: number;
  lose: number;
  played: number;
  win: number;
};

export type LeagueStandingsStandingsItem = {
  all: LeagueStandingsStandingsItemAll;
  away: LeagueStandingsStandingsItemAway;
  form: string;
  goalsDiff: number;
  home: LeagueStandingsStandingsItemHome;
  points: number;
  rank: number;
  team: LeagueStandingsStandingsItemTeam;
};

export type LeagueStandingsLeague = {
  country: string;
  id: number;
  name: string;
  season: number;
};

export interface TeamStatisticsData {
  ball_possessions: number;
  cards: number;
  conceded_goals: number;
  corners: number;
  expected_goals: number;
  scored_goals: number;
  shots_on_target: number;
  total_shots: number;
}

export type StandingsBreakdownGoals = {
  against: number;
  goals_for: number;
};

export interface StandingsBreakdown {
  draw: number;
  goals: StandingsBreakdownGoals;
  lose: number;
  played: number;
  win: number;
}

export interface TeamStandings {
  all: StandingsBreakdown;
  away: StandingsBreakdown;
  form: string;
  goalsDiff: number;
  group: string;
  home: StandingsBreakdown;
  points: number;
  rank: number;
}

/**
 * @nullable
 */
export type TeamStatisticsResponseForm = {
  away: TeamStandings;
  home: TeamStandings;
} | null;

export type TipAnalysisRiskLevel =
  (typeof TipAnalysisRiskLevel)[keyof typeof TipAnalysisRiskLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TipAnalysisRiskLevel = {
  High: "High",
  Moderate: "Moderate",
  Low: "Low",
} as const;

export interface TipAnalysisRiskItem {
  level: TipAnalysisRiskLevel;
  reasoning: string;
  title: string;
}

export interface TipAnalysisItem {
  id: string;
  reasoning: string;
  risks: TipAnalysisRiskItem[];
}

export interface GetInitialFiltersQueryParams {
  from?: string;
  to?: string;
  type: TipType;
}

/**
 * Construct a type with the properties of T except for those in type K.
 */
export type OmitGetTipsQueryParamsType =
  PickGetTipsQueryParamsExcludeKeyofGetTipsQueryParamsType;

export interface GetUpcomingTipCountsQueryParams {
  /** Start instant, ISO-8601, inclusive. */
  from: string;
  /** End instant, ISO-8601, exclusive. At most 168 hours after `from`. */
  to: string;
  type: TipType;
}

export type UpcomingTipCountsTotals = {
  fixtures: number;
  tips: number;
};

export type UpcomingTipCountsHoursItem = {
  fixtures: number;
  /** Hour start, Budapest wall clock, "YYYY-MM-DD HH:mm". */
  local: string;
  /** Hour start, UTC ISO-8601. */
  start: string;
  tips: number;
};

export interface UpcomingTipCounts {
  from: string;
  /** One entry per kickoff hour that has tips. */
  hours: UpcomingTipCountsHoursItem[];
  timezone: string;
  to: string;
  totals: UpcomingTipCountsTotals;
}

export interface GetTipsDailyBreakdownQueryParams {
  best_choice?: boolean;
  fixture_ids?: string[];
  /** First Budapest calendar day, YYYY-MM-DD. */
  from: string;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  /** Last Budapest calendar day, YYYY-MM-DD, inclusive. At most 62 days after `from`. */
  to: string;
  type: TipType;
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickGetTipsQueryParamsExcludeKeyofGetTipsQueryParamsIncludeTipStatusOrFromOrTo {
  best_choice?: boolean;
  fixture_ids?: string[];
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  type: TipType;
}

export type TipsDailyBreakdownTotalsAllOf = {
  /** Days with at least one settled tip. */
  days: number;
  /** Days whose profit is above zero. */
  profitable_days: number;
};

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickTipsDailyBreakdownDayExcludeKeyofTipsDailyBreakdownDayDate {
  /** won / (won + lost), in percent. */
  hit_rate: number;
  lost: number;
  /** In bet_amount units, as on /tips/summary. */
  profit: number;
  push: number;
  roi: number;
  /** won + lost + push. */
  settled: number;
  staked: number;
  tips: number;
  unsettled: number;
  won: number;
}

export type TipsDailyBreakdownTotals =
  PickTipsDailyBreakdownDayExcludeKeyofTipsDailyBreakdownDayDate &
    TipsDailyBreakdownTotalsAllOf;

export interface TipsDailyBreakdown {
  /** Only days with at least one tip. */
  days: TipsDailyBreakdownDay[];
  from: string;
  timezone: string;
  to: string;
  totals: TipsDailyBreakdownTotals;
}

/**
 * Construct a type with the properties of T except for those in type K.
 */
export type OmitTipsDailyBreakdownDayDate =
  PickTipsDailyBreakdownDayExcludeKeyofTipsDailyBreakdownDayDate;

export interface TipsDailyBreakdownDay {
  /** Budapest calendar day of the tips' kickoff, YYYY-MM-DD. */
  date: string;
  /** won / (won + lost), in percent. */
  hit_rate: number;
  lost: number;
  /** In bet_amount units, as on /tips/summary. */
  profit: number;
  push: number;
  roi: number;
  /** won + lost + push. */
  settled: number;
  staked: number;
  tips: number;
  unsettled: number;
  won: number;
}

export interface GetTopPerformersQueryParams {
  from?: string;
  to?: string;
  type: TipType;
}

export interface PerformerPropsRatings {
  avg_odds: number;
  hit_rate: number;
  key: Ratings;
  profit_loss: number;
  roi: number;
  total_tips: number;
}

export interface PerformerPropsCategory {
  avg_odds: number;
  hit_rate: number;
  key: Category;
  profit_loss: number;
  roi: number;
  total_tips: number;
}

export interface PerformerPropsLeague {
  avg_odds: number;
  hit_rate: number;
  key: League;
  profit_loss: number;
  roi: number;
  total_tips: number;
}

export interface TopPerformers {
  by_category: PerformerPropsCategory[];
  by_league: PerformerPropsLeague[];
  by_rating: PerformerPropsRatings[];
}

export interface GetTipsSummaryQueryParams {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  initialBankroll?: number;
  kellyFraction?: number;
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  to?: string;
  type: TipType;
}

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickGetTipsQueryParamsExcludeKeyofGetTipsQueryParamsIncludeTipStatus {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  to?: string;
  type: TipType;
}

export type TipSummaryBankrollOverTime = {
  default: BankrollStrategySummaryRecord;
  flat_betting: BankrollStrategySummaryRecord;
  kelly_criterion: BankrollStrategySummaryRecord;
};

export interface TipSummary {
  avg_bet_amount: number;
  avg_odds: number;
  avg_probability: number;
  bankrollOverTime: TipSummaryBankrollOverTime;
  brier_score: number;
  hit_rate: number;
  profit_loss: number;
  roi: number;
  total_lost: number;
  total_matches: number;
  total_push: number;
  total_staked: number;
  total_tips: number;
  total_unsettled: number;
  total_won: number;
}

export type GetUpcomingTipsQueryParamsGroupBy =
  (typeof GetUpcomingTipsQueryParamsGroupBy)[keyof typeof GetUpcomingTipsQueryParamsGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUpcomingTipsQueryParamsGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export interface GetUpcomingTipsQueryParams {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  groupBy?: GetUpcomingTipsQueryParamsGroupBy;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  page?: number;
  pageSize?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  to?: string;
  type: TipType;
}

export type GetTipsPerformanceQueryParamsGroupBy =
  (typeof GetTipsPerformanceQueryParamsGroupBy)[keyof typeof GetTipsPerformanceQueryParamsGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipsPerformanceQueryParamsGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export interface GetTipsPerformanceQueryParams {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  groupBy?: GetTipsPerformanceQueryParamsGroupBy;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  page?: number;
  pageSize?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  to?: string;
  type: TipType;
}

export type PickGetTipsMatchesQueryParamsExcludeKeyofGetTipsMatchesQueryParamsIncludeMatchStatusOrIncludeTipStatusGroupBy =
  (typeof PickGetTipsMatchesQueryParamsExcludeKeyofGetTipsMatchesQueryParamsIncludeMatchStatusOrIncludeTipStatusGroupBy)[keyof typeof PickGetTipsMatchesQueryParamsExcludeKeyofGetTipsMatchesQueryParamsIncludeMatchStatusOrIncludeTipStatusGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PickGetTipsMatchesQueryParamsExcludeKeyofGetTipsMatchesQueryParamsIncludeMatchStatusOrIncludeTipStatusGroupBy =
  {
    fixture: "fixture",
    individual: "individual",
  } as const;

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickGetTipsMatchesQueryParamsExcludeKeyofGetTipsMatchesQueryParamsIncludeMatchStatusOrIncludeTipStatus {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  groupBy?: PickGetTipsMatchesQueryParamsExcludeKeyofGetTipsMatchesQueryParamsIncludeMatchStatusOrIncludeTipStatusGroupBy;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  page?: number;
  pageSize?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  to?: string;
  type: TipType;
}

export type GetTipsMatchesQueryParamsGroupBy =
  (typeof GetTipsMatchesQueryParamsGroupBy)[keyof typeof GetTipsMatchesQueryParamsGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipsMatchesQueryParamsGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type MatchStatus = (typeof MatchStatus)[keyof typeof MatchStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MatchStatus = {
  live: "live",
  "not-started": "not-started",
  finished: "finished",
} as const;

export interface GetTipsMatchesQueryParams {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  groupBy?: GetTipsMatchesQueryParamsGroupBy;
  include_categories?: Category[];
  include_leagues?: number[];
  include_match_status?: MatchStatus[];
  include_ratings?: Ratings[];
  include_tip_status?: TipStatus[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  page?: number;
  pageSize?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  to?: string;
  type: TipType;
}

export interface IndividualTipsResponse {
  currentPage: number;
  data: Tip[];
  totalItems: number;
  totalPages: number;
  totalTips: number;
}

export interface TipsWithFixture {
  fixture: FixtureItem;
  tips: Tip[];
}

export interface TipsWithFixtureResponse {
  currentPage: number;
  data: TipsWithFixture[];
  totalItems: number;
  totalPages: number;
  totalTips: number;
}

export interface TutorialVideo {
  id: string;
  youtubeUrl: string;
}

export interface GetTutorialVideosResponse {
  tutorialVideos: TutorialVideo[];
}

export type BooleanStringAttribute =
  (typeof BooleanStringAttribute)[keyof typeof BooleanStringAttribute];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BooleanStringAttribute = {
  true: "true",
  false: "false",
} as const;

export interface UserAttributes {
  "custom:feedbackSurvey": BooleanStringAttribute;
  "custom:locale": string;
  "custom:marketingEmails": BooleanStringAttribute;
  "custom:newsLetters": BooleanStringAttribute;
  "custom:platformUpdates": BooleanStringAttribute;
  "custom:signupTracked": BooleanStringAttribute;
  email: string;
  email_verified: BooleanStringAttribute;
  family_name: string;
  given_name: string;
  name: string;
  sub: string;
}

export interface EmailPreferences {
  feedbackSurvey: boolean;
  marketingEmails: boolean;
  newsLetters: boolean;
  platformUpdates: boolean;
}

export interface ValidateRecaptchaBody {
  token: string;
}

export type ValidateRecaptchaResponseDetails = {
  challenge_ts?: string;
  hostname?: string;
};

export type RecaptchaErrorCode =
  (typeof RecaptchaErrorCode)[keyof typeof RecaptchaErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecaptchaErrorCode = {
  "missing-input-secret": "missing-input-secret",
  "invalid-input-secret": "invalid-input-secret",
  "missing-input-response": "missing-input-response",
  "invalid-input-response": "invalid-input-response",
  "bad-request": "bad-request",
  "timeout-or-duplicate": "timeout-or-duplicate",
} as const;

export interface ValidateRecaptchaResponse {
  details?: ValidateRecaptchaResponseDetails;
  /** @nullable */
  error: string | null;
  errorCodes?: RecaptchaErrorCode[];
  /** @nullable */
  message: string | null;
  success: boolean;
}

export interface CheckEmailResponse {
  error?: string;
  errorCode?: string;
  family_name: string;
  given_name: string;
  hasUser: boolean;
  name: string;
  user_status: string;
}

export interface DismissTutorialVideoBody {
  tutorialVideoId: string;
}

export interface DismissTutorialVideoResponse {
  error?: string;
  success: boolean;
}

export type UpdateUserPreferencesInputAllOf = {
  currency?: string;
  force?: boolean;
};

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickPartialUserPreferencesExcludeKeyofPartialUserPreferencesIdOrCurrency {
  allowResultOrientedV2?: boolean;
  allowValueBasedV2?: boolean;
  bankroll?: number;
  dismissedTelegramPermanently?: boolean;
  dismissedTutorialVideos?: string[];
  hasActiveSubscription?: boolean;
  kellyFraction?: number;
  telegramDismissedAt?: number;
  telegramJoined?: boolean;
  telegramStale?: boolean;
}

export type UpdateUserPreferencesInput =
  PickPartialUserPreferencesExcludeKeyofPartialUserPreferencesIdOrCurrency &
    UpdateUserPreferencesInputAllOf;

/**
 * Construct a type with the properties of T except for those in type K.
 */
export type OmitPartialUserPreferencesIdOrCurrency =
  PickPartialUserPreferencesExcludeKeyofPartialUserPreferencesIdOrCurrency;

export interface UpdateUserPreferencesResponse {
  error?: string;
  message: string;
  success?: boolean;
}

export interface Currency {
  code: string;
  locale: string;
  name: string;
  symbol: string;
}

export interface UserPreferences {
  allowResultOrientedV2?: boolean;
  allowValueBasedV2?: boolean;
  bankroll?: number;
  currency: Currency;
  dismissedTelegramPermanently: boolean;
  dismissedTutorialVideos?: string[];
  hasActiveSubscription: boolean;
  id: string;
  kellyFraction: number;
  telegramDismissedAt?: number;
  telegramJoined: boolean;
  telegramStale?: boolean;
}

export interface UpdateTelegramBody {
  dismissedTelegramPermanently: boolean;
  telegramJoined: boolean;
}

export interface UpdateTelegramPreferencesResponse {
  error?: string;
  success: boolean;
}

export interface CreateUserSourceBody {
  referrer?: string;
  source: string;
  utm_source: string;
}

export interface UserSource {
  created_at?: string;
  id: string;
  ip_address?: string;
  referrer?: string;
  source: string;
  utm_source: string;
}

export interface UserTipBody {
  bet_amount: number;
  id: string;
  odds: number;
}

export interface GetUserTipsSummaryResponse {
  avg_bet_amount: number;
  avg_odds: number;
  avg_probability: number;
  bankrollOverTime: GetUserTipsSummaryResponseBankrollOverTime;
  brier_score: number;
  hit_rate: number;
  profit_loss: number;
  roi: number;
  total_lost: number;
  total_matches: number;
  total_push: number;
  total_staked: number;
  total_tips: number;
  total_unsettled: number;
  total_won: number;
}

export interface BankrollStrategySummaryDataItem {
  bankroll: number;
  date: string;
  tip_id: string;
}

export interface BankrollStrategySummaryRecord {
  bankroll: number;
  data: BankrollStrategySummaryDataItem[];
  hit_rate: number;
  name: string;
  profit_loss: number;
  roi_percent: number;
  total_evaluated_bets: number;
  total_lost: number;
  total_push: number;
  total_staked: number;
  total_unsettled: number;
  total_won: number;
}

export type GetUserTipsSummaryResponseBankrollOverTime = {
  default: BankrollStrategySummaryRecord;
  flat_betting: BankrollStrategySummaryRecord;
  kelly_criterion: BankrollStrategySummaryRecord;
};

export type GetUserTipsQueryParamsGroupBy =
  (typeof GetUserTipsQueryParamsGroupBy)[keyof typeof GetUserTipsQueryParamsGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserTipsQueryParamsGroupBy = {
  fixture: "fixture",
  individual: "individual",
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type SortField = (typeof SortField)[keyof typeof SortField];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortField = {
  date: "date",
  category: "category",
  probability: "probability",
  odds: "odds",
  stake: "stake",
  edge: "edge",
} as const;

export type TipStatus = (typeof TipStatus)[keyof typeof TipStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TipStatus = {
  won: "won",
  lost: "lost",
  push: "push",
  unsettled: "unsettled",
} as const;

/**
 * From T, pick a set of properties whose keys are in the union K
 */
export interface PickGetTipsQueryParamsExcludeKeyofGetTipsQueryParamsType {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  include_tip_status?: TipStatus[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  to?: string;
}

export type IndividualUserTipsResponseDataItemAllOf = {
  fixture?: FixtureItem;
};

export type IndividualUserTipsResponseDataItem = UserTip &
  IndividualUserTipsResponseDataItemAllOf;

export interface IndividualUserTipsResponse {
  currentPage: number;
  data: IndividualUserTipsResponseDataItem[];
  totalItems: number;
  totalPages: number;
  totalTips: number;
}

export interface UserTipsWithFixture {
  fixture: FixtureItem;
  tips: UserTip[];
}

export interface UserTipsWithFixtureResponse {
  currentPage: number;
  data: UserTipsWithFixture[];
  totalItems: number;
  totalPages: number;
  totalTips: number;
}

export type TipType = (typeof TipType)[keyof typeof TipType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TipType = {
  value: "value",
  resultOriented: "resultOriented",
  "value-v2": "value-v2",
} as const;

export type UserTipAllOf = {
  currency: string;
  type: TipType;
  user_id: string;
};

export type Category = (typeof Category)[keyof typeof Category];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Category = {
  Match_Winner: "Match Winner",
  "First-Half_Result": "First-Half Result",
  "Second-Half_Result": "Second-Half Result",
  "Total_Goals_Over/Under": "Total Goals Over/Under",
  "Home_Goals_Over/Under": "Home Goals Over/Under",
  "Away_Goals_Over/Under": "Away Goals Over/Under",
  Both_Teams_to_Score: "Both Teams to Score",
  Player_to_Score: "Player to Score",
  Player_to_Score_or_Assist: "Player to Score or Assist",
  "Total_Corners_Over/Under": "Total Corners Over/Under",
  "Home_Corners_Over/Under": "Home Corners Over/Under",
  "Away_Corners_Over/Under": "Away Corners Over/Under",
  "Total_Cards_Over/Under": "Total Cards Over/Under",
  "Home_Cards_Over/Under": "Home Cards Over/Under",
  "Away_Cards_Over/Under": "Away Cards Over/Under",
  Asian_Handicap: "Asian Handicap",
  Draw_No_Bet: "Draw No Bet",
  Double_Chance: "Double Chance",
  Correct_Score: "Correct Score",
  Team_to_Score_First: "Team to Score First",
  Both_Teams_to_Score_in_Both_Halves: "Both Teams to Score in Both Halves",
  Team_to_Score_in_Both_Halves: "Team to Score in Both Halves",
  Clean_Sheet: "Clean Sheet",
  Win_to_Nil: "Win to Nil",
  Penalty_Awarded: "Penalty Awarded",
  Red_Card_Shown: "Red Card Shown",
} as const;

export type Ratings = (typeof Ratings)[keyof typeof Ratings];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Ratings = {
  super_safe: "super safe",
  safe: "safe",
  value: "value",
  risky: "risky",
} as const;

export interface GetUserTipsQueryParams {
  best_choice?: boolean;
  fixture_ids?: string[];
  from?: string;
  groupBy?: GetUserTipsQueryParamsGroupBy;
  include_categories?: Category[];
  include_leagues?: number[];
  include_ratings?: Ratings[];
  include_tip_status?: TipStatus[];
  max_edge?: number;
  max_match_importance?: number;
  max_odds?: number;
  max_predictability?: number;
  max_probability?: number;
  max_stake?: number;
  min_edge?: number;
  min_match_importance?: number;
  min_odds?: number;
  min_predictability?: number;
  min_probability?: number;
  min_stake?: number;
  page?: number;
  pageSize?: number;
  safe_to_bet?: boolean;
  season?: number;
  sortBy?: SortField;
  sortOrder?: SortOrder;
  to?: string;
  type?: TipType;
}

export interface Tip {
  best_choice: boolean;
  bet_amount: number;
  category: Category;
  edge: number;
  fixture?: FixtureItem;
  fixture_id: string;
  id: string;
  league_id: number;
  name: string;
  odds: number;
  probability: number;
  rating: Ratings;
  reasoning: string;
  season: number;
  start_date: string;
  /** @nullable */
  winner?: boolean | null;
}

export type UserTip = Tip & UserTipAllOf;

export interface Score {
  /** @nullable */
  away: number | null;
  /** @nullable */
  home: number | null;
}

export interface ScoreRecord {
  extratime: Score;
  fulltime: Score;
  halftime: Score;
  penalty: Score;
}

export interface Team {
  id: number;
  logo: string;
  name: string;
  /** @nullable */
  winner: boolean | null;
}

export interface TeamsRecord {
  away: Team;
  home: Team;
}

export type LeagueId = number | string;

export interface League {
  country?: string;
  flag?: string;
  id: LeagueId;
  logo: string;
  name: string;
  round?: string;
  season?: number;
  type?: string;
}

export interface FixtureItem {
  fixture: Fixture;
  goals: Score;
  league: League;
  score: ScoreRecord;
  teams: TeamsRecord;
}

export type FixtureVenue = {
  city: string;
  /** @nullable */
  id: number | null;
  name: string;
};

export type FixturePeriods = {
  first: number;
  second: number;
};

export interface FixtureStatusResponse {
  elapsed: number;
  long: string;
  short: string;
}

export interface Fixture {
  date: string;
  id: number;
  periods: FixturePeriods;
  referee: string;
  status: FixtureStatusResponse;
  timestamp: number;
  timezone: string;
  venue: FixtureVenue;
}

export const getUserTips = (
  params?: GetUserTipsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetUserTips200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/user-tips`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetUserTipsQueryKey = (params?: GetUserTipsParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/user-tips`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserTipsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserTips>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTips>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserTipsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserTips>>> = ({
    signal,
  }) => getUserTips(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserTips>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserTipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserTips>>
>;
export type GetUserTipsQueryError = AxiosError<unknown>;

export function useGetUserTips<
  TData = Awaited<ReturnType<typeof getUserTips>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetUserTipsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTips>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTips>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserTips<
  TData = Awaited<ReturnType<typeof getUserTips>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTips>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTips>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserTips<
  TData = Awaited<ReturnType<typeof getUserTips>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTips>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserTips<
  TData = Awaited<ReturnType<typeof getUserTips>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTips>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserTipsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createUserTip = (
  userTipBody: UserTipBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/user-tips`,
    userTipBody,
    options,
  );
};

export const getCreateUserTipMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserTip>>,
    TError,
    { data: UserTipBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUserTip>>,
  TError,
  { data: UserTipBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUserTip>>,
    { data: UserTipBody }
  > = (props) => {
    const { data } = props ?? {};

    return createUserTip(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserTipMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUserTip>>
>;
export type CreateUserTipMutationBody = UserTipBody;
export type CreateUserTipMutationError = AxiosError<unknown>;

export const useCreateUserTip = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserTip>>,
    TError,
    { data: UserTipBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUserTip>>,
  TError,
  { data: UserTipBody },
  TContext
> => {
  const mutationOptions = getCreateUserTipMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteUserTips = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/user-tips`,
    options,
  );
};

export const getDeleteUserTipsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserTips>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserTips>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserTips>>,
    void
  > = () => {
    return deleteUserTips(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserTipsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserTips>>
>;

export type DeleteUserTipsMutationError = AxiosError<unknown>;

export const useDeleteUserTips = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserTips>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserTips>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteUserTipsMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getUserTipsSummary = (
  params?: GetUserTipsSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetUserTipsSummaryResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/user-tips/summary`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetUserTipsSummaryQueryKey = (
  params?: GetUserTipsSummaryParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/user-tips/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserTipsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserTipsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTipsSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserTipsSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserTipsSummary>>
  > = ({ signal }) => getUserTipsSummary(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserTipsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserTipsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserTipsSummary>>
>;
export type GetUserTipsSummaryQueryError = AxiosError<unknown>;

export function useGetUserTipsSummary<
  TData = Awaited<ReturnType<typeof getUserTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetUserTipsSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTipsSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTipsSummary>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserTipsSummary<
  TData = Awaited<ReturnType<typeof getUserTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserTipsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTipsSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTipsSummary>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserTipsSummary<
  TData = Awaited<ReturnType<typeof getUserTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserTipsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTipsSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserTipsSummary<
  TData = Awaited<ReturnType<typeof getUserTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserTipsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserTipsSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserTipsSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUserTip = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserTip>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/user-tips/${id}`,
    options,
  );
};

export const getGetUserTipQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/user-tips/${id}`,
  ] as const;
};

export const getGetUserTipQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserTip>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTip>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserTipQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserTip>>> = ({
    signal,
  }) => getUserTip(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserTip>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserTipQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserTip>>
>;
export type GetUserTipQueryError = AxiosError<unknown>;

export function useGetUserTip<
  TData = Awaited<ReturnType<typeof getUserTip>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTip>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTip>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserTip<
  TData = Awaited<ReturnType<typeof getUserTip>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTip>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTip>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserTip<
  TData = Awaited<ReturnType<typeof getUserTip>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTip>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserTip<
  TData = Awaited<ReturnType<typeof getUserTip>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserTip>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserTipQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteUserTip = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteUserTip200>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/user-tips/${id}`,
    options,
  );
};

export const getDeleteUserTipMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserTip>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserTip>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserTip>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteUserTip(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserTipMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserTip>>
>;

export type DeleteUserTipMutationError = AxiosError<unknown>;

export const useDeleteUserTip = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserTip>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserTip>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteUserTipMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getUserSource = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserSource>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/user-source`,
    options,
  );
};

export const getGetUserSourceQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/user-source`,
  ] as const;
};

export const getGetUserSourceQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserSource>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserSource>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserSourceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSource>>> = ({
    signal,
  }) => getUserSource({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserSource>>
>;
export type GetUserSourceQueryError = AxiosError<unknown>;

export function useGetUserSource<
  TData = Awaited<ReturnType<typeof getUserSource>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserSource>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserSource>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserSource<
  TData = Awaited<ReturnType<typeof getUserSource>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserSource>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserSource>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSource<
  TData = Awaited<ReturnType<typeof getUserSource>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserSource>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserSource<
  TData = Awaited<ReturnType<typeof getUserSource>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserSource>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserSourceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createUserSource = (
  createUserSourceBody: CreateUserSourceBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserSource>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/user-source`,
    createUserSourceBody,
    options,
  );
};

export const getCreateUserSourceMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserSource>>,
    TError,
    { data: CreateUserSourceBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUserSource>>,
  TError,
  { data: CreateUserSourceBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUserSource>>,
    { data: CreateUserSourceBody }
  > = (props) => {
    const { data } = props ?? {};

    return createUserSource(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUserSource>>
>;
export type CreateUserSourceMutationBody = CreateUserSourceBody;
export type CreateUserSourceMutationError = AxiosError<unknown>;

export const useCreateUserSource = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUserSource>>,
    TError,
    { data: CreateUserSourceBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUserSource>>,
  TError,
  { data: CreateUserSourceBody },
  TContext
> => {
  const mutationOptions = getCreateUserSourceMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateTelegramPreferences = (
  updateTelegramBody: UpdateTelegramBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpdateTelegramPreferencesResponse>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/user-preferences/telegram-preferences`,
    updateTelegramBody,
    options,
  );
};

export const getUpdateTelegramPreferencesMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTelegramPreferences>>,
    TError,
    { data: UpdateTelegramBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTelegramPreferences>>,
  TError,
  { data: UpdateTelegramBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTelegramPreferences>>,
    { data: UpdateTelegramBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateTelegramPreferences(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTelegramPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTelegramPreferences>>
>;
export type UpdateTelegramPreferencesMutationBody = UpdateTelegramBody;
export type UpdateTelegramPreferencesMutationError = AxiosError<unknown>;

export const useUpdateTelegramPreferences = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTelegramPreferences>>,
    TError,
    { data: UpdateTelegramBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTelegramPreferences>>,
  TError,
  { data: UpdateTelegramBody },
  TContext
> => {
  const mutationOptions = getUpdateTelegramPreferencesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getUserPreferences = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserPreferences>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/user-preferences`,
    options,
  );
};

export const getGetUserPreferencesQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/user-preferences`,
  ] as const;
};

export const getGetUserPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPreferences>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserPreferences>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPreferences>>
  > = ({ signal }) => getUserPreferences({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPreferences>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPreferences>>
>;
export type GetUserPreferencesQueryError = AxiosError<unknown>;

export function useGetUserPreferences<
  TData = Awaited<ReturnType<typeof getUserPreferences>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserPreferences>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserPreferences>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserPreferences<
  TData = Awaited<ReturnType<typeof getUserPreferences>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserPreferences>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserPreferences>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserPreferences<
  TData = Awaited<ReturnType<typeof getUserPreferences>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserPreferences>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserPreferences<
  TData = Awaited<ReturnType<typeof getUserPreferences>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserPreferences>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateUserPreferences = (
  updateUserPreferencesInput: UpdateUserPreferencesInput,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpdateUserPreferencesResponse>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/user-preferences`,
    updateUserPreferencesInput,
    options,
  );
};

export const getUpdateUserPreferencesMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    TError,
    { data: UpdateUserPreferencesInput },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserPreferences>>,
  TError,
  { data: UpdateUserPreferencesInput },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    { data: UpdateUserPreferencesInput }
  > = (props) => {
    const { data } = props ?? {};

    return updateUserPreferences(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserPreferences>>
>;
export type UpdateUserPreferencesMutationBody = UpdateUserPreferencesInput;
export type UpdateUserPreferencesMutationError = AxiosError<unknown>;

export const useUpdateUserPreferences = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    TError,
    { data: UpdateUserPreferencesInput },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserPreferences>>,
  TError,
  { data: UpdateUserPreferencesInput },
  TContext
> => {
  const mutationOptions = getUpdateUserPreferencesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const dismissTutorialVideo = (
  dismissTutorialVideoBody: DismissTutorialVideoBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DismissTutorialVideoResponse>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/user-preferences/dismiss-tutorial-video`,
    dismissTutorialVideoBody,
    options,
  );
};

export const getDismissTutorialVideoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissTutorialVideo>>,
    TError,
    { data: DismissTutorialVideoBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissTutorialVideo>>,
  TError,
  { data: DismissTutorialVideoBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissTutorialVideo>>,
    { data: DismissTutorialVideoBody }
  > = (props) => {
    const { data } = props ?? {};

    return dismissTutorialVideo(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissTutorialVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissTutorialVideo>>
>;
export type DismissTutorialVideoMutationBody = DismissTutorialVideoBody;
export type DismissTutorialVideoMutationError = AxiosError<unknown>;

export const useDismissTutorialVideo = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissTutorialVideo>>,
    TError,
    { data: DismissTutorialVideoBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissTutorialVideo>>,
  TError,
  { data: DismissTutorialVideoBody },
  TContext
> => {
  const mutationOptions = getDismissTutorialVideoMutationOptions(options);

  return useMutation(mutationOptions);
};

export const checkEmail = (
  email: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CheckEmailResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/user-pool/check-email/${email}`,
    options,
  );
};

export const getCheckEmailQueryKey = (email: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/user-pool/check-email/${email}`,
  ] as const;
};

export const getCheckEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof checkEmail>>,
  TError = AxiosError<unknown>,
>(
  email: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkEmail>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckEmailQueryKey(email);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkEmail>>> = ({
    signal,
  }) => checkEmail(email, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!email,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CheckEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkEmail>>
>;
export type CheckEmailQueryError = AxiosError<unknown>;

export function useCheckEmail<
  TData = Awaited<ReturnType<typeof checkEmail>>,
  TError = AxiosError<unknown>,
>(
  email: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkEmail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkEmail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCheckEmail<
  TData = Awaited<ReturnType<typeof checkEmail>>,
  TError = AxiosError<unknown>,
>(
  email: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkEmail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkEmail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCheckEmail<
  TData = Awaited<ReturnType<typeof checkEmail>>,
  TError = AxiosError<unknown>,
>(
  email: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkEmail>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useCheckEmail<
  TData = Awaited<ReturnType<typeof checkEmail>>,
  TError = AxiosError<unknown>,
>(
  email: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkEmail>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCheckEmailQueryOptions(email, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const validateRecaptcha = (
  validateRecaptchaBody: ValidateRecaptchaBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ValidateRecaptchaResponse>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/user-pool/validate-recaptcha`,
    validateRecaptchaBody,
    options,
  );
};

export const getValidateRecaptchaMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateRecaptcha>>,
    TError,
    { data: ValidateRecaptchaBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateRecaptcha>>,
  TError,
  { data: ValidateRecaptchaBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateRecaptcha>>,
    { data: ValidateRecaptchaBody }
  > = (props) => {
    const { data } = props ?? {};

    return validateRecaptcha(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateRecaptchaMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateRecaptcha>>
>;
export type ValidateRecaptchaMutationBody = ValidateRecaptchaBody;
export type ValidateRecaptchaMutationError = AxiosError<unknown>;

export const useValidateRecaptcha = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateRecaptcha>>,
    TError,
    { data: ValidateRecaptchaBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof validateRecaptcha>>,
  TError,
  { data: ValidateRecaptchaBody },
  TContext
> => {
  const mutationOptions = getValidateRecaptchaMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteUser = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/user-pool/delete-user`,
    options,
  );
};

export const getDeleteUserMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    void
  > = () => {
    return deleteUser(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUser>>
>;

export type DeleteUserMutationError = AxiosError<unknown>;

export const useDeleteUser = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteUserMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getEmailPreferences = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EmailPreferences>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/user-pool/email-preferences/${id}`,
    options,
  );
};

export const getGetEmailPreferencesQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/user-pool/email-preferences/${id}`,
  ] as const;
};

export const getGetEmailPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailPreferences>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmailPreferences>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailPreferencesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailPreferences>>
  > = ({ signal }) => getEmailPreferences(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailPreferences>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEmailPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailPreferences>>
>;
export type GetEmailPreferencesQueryError = AxiosError<unknown>;

export function useGetEmailPreferences<
  TData = Awaited<ReturnType<typeof getEmailPreferences>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmailPreferences>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailPreferences>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmailPreferences<
  TData = Awaited<ReturnType<typeof getEmailPreferences>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmailPreferences>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailPreferences>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmailPreferences<
  TData = Awaited<ReturnType<typeof getEmailPreferences>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmailPreferences>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetEmailPreferences<
  TData = Awaited<ReturnType<typeof getEmailPreferences>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEmailPreferences>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEmailPreferencesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateEmailPreferences = (
  id: string,
  emailPreferences: EmailPreferences,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/user-pool/email-preferences/${id}`,
    emailPreferences,
    options,
  );
};

export const getUpdateEmailPreferencesMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailPreferences>>,
    TError,
    { id: string; data: EmailPreferences },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailPreferences>>,
  TError,
  { id: string; data: EmailPreferences },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailPreferences>>,
    { id: string; data: EmailPreferences }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateEmailPreferences(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailPreferences>>
>;
export type UpdateEmailPreferencesMutationBody = EmailPreferences;
export type UpdateEmailPreferencesMutationError = AxiosError<unknown>;

export const useUpdateEmailPreferences = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailPreferences>>,
    TError,
    { id: string; data: EmailPreferences },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailPreferences>>,
  TError,
  { id: string; data: EmailPreferences },
  TContext
> => {
  const mutationOptions = getUpdateEmailPreferencesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const welcome = (
  welcomeBody?: WelcomeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/user-pool/welcome`,
    welcomeBody,
    options,
  );
};

export const getWelcomeMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof welcome>>,
    TError,
    { data: WelcomeBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof welcome>>,
  TError,
  { data: WelcomeBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof welcome>>,
    { data: WelcomeBody }
  > = (props) => {
    const { data } = props ?? {};

    return welcome(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WelcomeMutationResult = NonNullable<
  Awaited<ReturnType<typeof welcome>>
>;
export type WelcomeMutationBody = WelcomeBody;
export type WelcomeMutationError = AxiosError<unknown>;

export const useWelcome = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof welcome>>,
    TError,
    { data: WelcomeBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof welcome>>,
  TError,
  { data: WelcomeBody },
  TContext
> => {
  const mutationOptions = getWelcomeMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getUserAttributes = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserAttributes>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/user-pool/attributes`,
    options,
  );
};

export const getGetUserAttributesQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/user-pool/attributes`,
  ] as const;
};

export const getGetUserAttributesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAttributes>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserAttributes>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserAttributesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserAttributes>>
  > = ({ signal }) => getUserAttributes({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAttributes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserAttributesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserAttributes>>
>;
export type GetUserAttributesQueryError = AxiosError<unknown>;

export function useGetUserAttributes<
  TData = Awaited<ReturnType<typeof getUserAttributes>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserAttributes>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserAttributes>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserAttributes<
  TData = Awaited<ReturnType<typeof getUserAttributes>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserAttributes>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserAttributes>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserAttributes<
  TData = Awaited<ReturnType<typeof getUserAttributes>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserAttributes>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUserAttributes<
  TData = Awaited<ReturnType<typeof getUserAttributes>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUserAttributes>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserAttributesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTutorialVideos = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetTutorialVideosResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tutorial-videos`,
    options,
  );
};

export const getGetTutorialVideosQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tutorial-videos`,
  ] as const;
};

export const getGetTutorialVideosQueryOptions = <
  TData = Awaited<ReturnType<typeof getTutorialVideos>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTutorialVideos>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTutorialVideosQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTutorialVideos>>
  > = ({ signal }) => getTutorialVideos({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTutorialVideos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTutorialVideosQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTutorialVideos>>
>;
export type GetTutorialVideosQueryError = AxiosError<unknown>;

export function useGetTutorialVideos<
  TData = Awaited<ReturnType<typeof getTutorialVideos>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTutorialVideos>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTutorialVideos>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTutorialVideos<
  TData = Awaited<ReturnType<typeof getTutorialVideos>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTutorialVideos>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTutorialVideos>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTutorialVideos<
  TData = Awaited<ReturnType<typeof getTutorialVideos>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTutorialVideos>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTutorialVideos<
  TData = Awaited<ReturnType<typeof getTutorialVideos>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTutorialVideos>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTutorialVideosQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTips = (
  params: GetTipsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetTips200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetTipsQueryKey = (params: GetTipsParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTipsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTips>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTips>>> = ({
    signal,
  }) => getTips(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTips>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTips>>
>;
export type GetTipsQueryError = AxiosError<unknown>;

export function useGetTips<
  TData = Awaited<ReturnType<typeof getTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTips>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTips>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTips<
  TData = Awaited<ReturnType<typeof getTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTips>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTips>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTips<
  TData = Awaited<ReturnType<typeof getTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTips>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTips<
  TData = Awaited<ReturnType<typeof getTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTips>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTipsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTipsPerformance = (
  params: GetTipsPerformanceParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetTipsPerformance200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/performance`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetTipsPerformanceQueryKey = (
  params: GetTipsPerformanceParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/performance`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTipsPerformanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipsPerformance>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsPerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipsPerformanceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipsPerformance>>
  > = ({ signal }) => getTipsPerformance(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTipsPerformance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTipsPerformanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipsPerformance>>
>;
export type GetTipsPerformanceQueryError = AxiosError<unknown>;

export function useGetTipsPerformance<
  TData = Awaited<ReturnType<typeof getTipsPerformance>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsPerformanceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsPerformance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipsPerformance>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTipsPerformance<
  TData = Awaited<ReturnType<typeof getTipsPerformance>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsPerformance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipsPerformance>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTipsPerformance<
  TData = Awaited<ReturnType<typeof getTipsPerformance>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsPerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTipsPerformance<
  TData = Awaited<ReturnType<typeof getTipsPerformance>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsPerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTipsPerformanceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUpcomingTips = (
  params: GetUpcomingTipsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetUpcomingTips200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/upcoming-tips`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetUpcomingTipsQueryKey = (params: GetUpcomingTipsParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/upcoming-tips`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUpcomingTipsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpcomingTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTips>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUpcomingTipsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingTips>>> = ({
    signal,
  }) => getUpcomingTips(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpcomingTips>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUpcomingTipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpcomingTips>>
>;
export type GetUpcomingTipsQueryError = AxiosError<unknown>;

export function useGetUpcomingTips<
  TData = Awaited<ReturnType<typeof getUpcomingTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTips>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingTips>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUpcomingTips<
  TData = Awaited<ReturnType<typeof getUpcomingTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTips>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingTips>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUpcomingTips<
  TData = Awaited<ReturnType<typeof getUpcomingTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTips>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUpcomingTips<
  TData = Awaited<ReturnType<typeof getUpcomingTips>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTips>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUpcomingTipsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTipsSummary = (
  params: GetTipsSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TipSummary>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/summary`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetTipsSummaryQueryKey = (params: GetTipsSummaryParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTipsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipsSummary>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipsSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipsSummary>>> = ({
    signal,
  }) => getTipsSummary(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTipsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTipsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipsSummary>>
>;
export type GetTipsSummaryQueryError = AxiosError<unknown>;

export function useGetTipsSummary<
  TData = Awaited<ReturnType<typeof getTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipsSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipsSummary>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTipsSummary<
  TData = Awaited<ReturnType<typeof getTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipsSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipsSummary>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTipsSummary<
  TData = Awaited<ReturnType<typeof getTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipsSummary>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTipsSummary<
  TData = Awaited<ReturnType<typeof getTipsSummary>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipsSummary>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTipsSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTopPerformers = (
  params: GetTopPerformersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TopPerformers>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/top-performers`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetTopPerformersQueryKey = (params: GetTopPerformersParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/top-performers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTopPerformersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopPerformers>>,
  TError = AxiosError<unknown>,
>(
  params: GetTopPerformersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTopPerformersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopPerformers>>
  > = ({ signal }) => getTopPerformers(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopPerformers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopPerformersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopPerformers>>
>;
export type GetTopPerformersQueryError = AxiosError<unknown>;

export function useGetTopPerformers<
  TData = Awaited<ReturnType<typeof getTopPerformers>>,
  TError = AxiosError<unknown>,
>(
  params: GetTopPerformersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPerformers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopPerformers<
  TData = Awaited<ReturnType<typeof getTopPerformers>>,
  TError = AxiosError<unknown>,
>(
  params: GetTopPerformersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopPerformers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopPerformers<
  TData = Awaited<ReturnType<typeof getTopPerformers>>,
  TError = AxiosError<unknown>,
>(
  params: GetTopPerformersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTopPerformers<
  TData = Awaited<ReturnType<typeof getTopPerformers>>,
  TError = AxiosError<unknown>,
>(
  params: GetTopPerformersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopPerformers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopPerformersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTipsDailyBreakdown = (
  params: GetTipsDailyBreakdownParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TipsDailyBreakdown>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/daily-breakdown`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetTipsDailyBreakdownQueryKey = (
  params: GetTipsDailyBreakdownParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/daily-breakdown`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTipsDailyBreakdownQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsDailyBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipsDailyBreakdownQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipsDailyBreakdown>>
  > = ({ signal }) =>
    getTipsDailyBreakdown(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTipsDailyBreakdownQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipsDailyBreakdown>>
>;
export type GetTipsDailyBreakdownQueryError = AxiosError<unknown>;

export function useGetTipsDailyBreakdown<
  TData = Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsDailyBreakdownParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTipsDailyBreakdown<
  TData = Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsDailyBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTipsDailyBreakdown<
  TData = Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsDailyBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTipsDailyBreakdown<
  TData = Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
  TError = AxiosError<unknown>,
>(
  params: GetTipsDailyBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsDailyBreakdown>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTipsDailyBreakdownQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUpcomingTipCounts = (
  params: GetUpcomingTipCountsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpcomingTipCounts>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/upcoming-counts`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetUpcomingTipCountsQueryKey = (
  params: GetUpcomingTipCountsParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/upcoming-counts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUpcomingTipCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUpcomingTipCounts>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipCountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTipCounts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUpcomingTipCountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUpcomingTipCounts>>
  > = ({ signal }) => getUpcomingTipCounts(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUpcomingTipCounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUpcomingTipCountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUpcomingTipCounts>>
>;
export type GetUpcomingTipCountsQueryError = AxiosError<unknown>;

export function useGetUpcomingTipCounts<
  TData = Awaited<ReturnType<typeof getUpcomingTipCounts>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipCountsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTipCounts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingTipCounts>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUpcomingTipCounts<
  TData = Awaited<ReturnType<typeof getUpcomingTipCounts>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipCountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTipCounts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingTipCounts>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUpcomingTipCounts<
  TData = Awaited<ReturnType<typeof getUpcomingTipCounts>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipCountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTipCounts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetUpcomingTipCounts<
  TData = Awaited<ReturnType<typeof getUpcomingTipCounts>>,
  TError = AxiosError<unknown>,
>(
  params: GetUpcomingTipCountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUpcomingTipCounts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUpcomingTipCountsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const initialFiltersGet = (
  params: InitialFiltersGetParams,
  options?: AxiosRequestConfig,
): Promise<
  AxiosResponse<PickGetTipsQueryParamsExcludeKeyofGetTipsQueryParamsType>
> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/initial-filters`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getInitialFiltersGetQueryKey = (
  params: InitialFiltersGetParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/initial-filters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getInitialFiltersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof initialFiltersGet>>,
  TError = AxiosError<unknown>,
>(
  params: InitialFiltersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initialFiltersGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getInitialFiltersGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof initialFiltersGet>>
  > = ({ signal }) => initialFiltersGet(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof initialFiltersGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type InitialFiltersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof initialFiltersGet>>
>;
export type InitialFiltersGetQueryError = AxiosError<unknown>;

export function useInitialFiltersGet<
  TData = Awaited<ReturnType<typeof initialFiltersGet>>,
  TError = AxiosError<unknown>,
>(
  params: InitialFiltersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initialFiltersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof initialFiltersGet>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useInitialFiltersGet<
  TData = Awaited<ReturnType<typeof initialFiltersGet>>,
  TError = AxiosError<unknown>,
>(
  params: InitialFiltersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initialFiltersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof initialFiltersGet>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useInitialFiltersGet<
  TData = Awaited<ReturnType<typeof initialFiltersGet>>,
  TError = AxiosError<unknown>,
>(
  params: InitialFiltersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initialFiltersGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useInitialFiltersGet<
  TData = Awaited<ReturnType<typeof initialFiltersGet>>,
  TError = AxiosError<unknown>,
>(
  params: InitialFiltersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof initialFiltersGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getInitialFiltersGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTipsByFixture = (
  id: string,
  params: GetTipsByFixtureParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Tip[]>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/fixture/${id}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetTipsByFixtureQueryKey = (
  id: string,
  params: GetTipsByFixtureParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/fixture/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTipsByFixtureQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipsByFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipsByFixtureParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipsByFixtureQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipsByFixture>>
  > = ({ signal }) => getTipsByFixture(id, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTipsByFixture>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTipsByFixtureQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipsByFixture>>
>;
export type GetTipsByFixtureQueryError = AxiosError<unknown>;

export function useGetTipsByFixture<
  TData = Awaited<ReturnType<typeof getTipsByFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipsByFixtureParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsByFixture>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipsByFixture>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTipsByFixture<
  TData = Awaited<ReturnType<typeof getTipsByFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipsByFixtureParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsByFixture>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipsByFixture>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTipsByFixture<
  TData = Awaited<ReturnType<typeof getTipsByFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipsByFixtureParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTipsByFixture<
  TData = Awaited<ReturnType<typeof getTipsByFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipsByFixtureParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTipsByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTipsByFixtureQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTipById = (
  id: string,
  params: GetTipByIdParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetTipById200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tips/${id}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetTipByIdQueryKey = (id: string, params: GetTipByIdParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tips/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTipByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipById>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipByIdQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipById>>> = ({
    signal,
  }) => getTipById(id, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTipById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTipByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipById>>
>;
export type GetTipByIdQueryError = AxiosError<unknown>;

export function useGetTipById<
  TData = Awaited<ReturnType<typeof getTipById>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipByIdParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTipById<
  TData = Awaited<ReturnType<typeof getTipById>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTipById<
  TData = Awaited<ReturnType<typeof getTipById>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTipById<
  TData = Awaited<ReturnType<typeof getTipById>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  params: GetTipByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipById>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTipByIdQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTipAnalysis = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TipAnalysisItem>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/tip-analysis/${id}`,
    options,
  );
};

export const getGetTipAnalysisQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/tip-analysis/${id}`,
  ] as const;
};

export const getGetTipAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipAnalysis>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipAnalysisQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipAnalysis>>> = ({
    signal,
  }) => getTipAnalysis(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTipAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTipAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipAnalysis>>
>;
export type GetTipAnalysisQueryError = AxiosError<unknown>;

export function useGetTipAnalysis<
  TData = Awaited<ReturnType<typeof getTipAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipAnalysis>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipAnalysis>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTipAnalysis<
  TData = Awaited<ReturnType<typeof getTipAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipAnalysis>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTipAnalysis>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTipAnalysis<
  TData = Awaited<ReturnType<typeof getTipAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipAnalysis>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTipAnalysis<
  TData = Awaited<ReturnType<typeof getTipAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTipAnalysis>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTipAnalysisQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeamStatistics = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TeamStatisticsResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/team-statistics/fixture/${fixtureId}`,
    options,
  );
};

export const getGetTeamStatisticsQueryKey = (fixtureId: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/team-statistics/fixture/${fixtureId}`,
  ] as const;
};

export const getGetTeamStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamStatistics>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamStatistics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTeamStatisticsQueryKey(fixtureId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeamStatistics>>
  > = ({ signal }) => getTeamStatistics(fixtureId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!fixtureId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamStatistics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeamStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamStatistics>>
>;
export type GetTeamStatisticsQueryError = AxiosError<unknown>;

export function useGetTeamStatistics<
  TData = Awaited<ReturnType<typeof getTeamStatistics>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeamStatistics<
  TData = Awaited<ReturnType<typeof getTeamStatistics>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamStatistics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeamStatistics<
  TData = Awaited<ReturnType<typeof getTeamStatistics>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamStatistics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeamStatistics<
  TData = Awaited<ReturnType<typeof getTeamStatistics>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamStatistics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeamStatisticsQueryOptions(fixtureId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getTeamNameAliases = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TeamNameAlias[]>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/team-name-aliases`,
    options,
  );
};

export const getGetTeamNameAliasesQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/team-name-aliases`,
  ] as const;
};

export const getGetTeamNameAliasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamNameAliases>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeamNameAliases>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamNameAliasesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeamNameAliases>>
  > = ({ signal }) => getTeamNameAliases({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamNameAliases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTeamNameAliasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamNameAliases>>
>;
export type GetTeamNameAliasesQueryError = AxiosError<unknown>;

export function useGetTeamNameAliases<
  TData = Awaited<ReturnType<typeof getTeamNameAliases>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeamNameAliases>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTeamNameAliases>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTeamNameAliases<
  TData = Awaited<ReturnType<typeof getTeamNameAliases>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeamNameAliases>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getTeamNameAliases>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTeamNameAliases<
  TData = Awaited<ReturnType<typeof getTeamNameAliases>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeamNameAliases>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetTeamNameAliases<
  TData = Awaited<ReturnType<typeof getTeamNameAliases>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTeamNameAliases>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTeamNameAliasesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createTeamNameAlias = (
  pickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt: PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TeamNameAlias>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/team-name-aliases`,
    pickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt,
    options,
  );
};

export const getCreateTeamNameAliasMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeamNameAlias>>,
    TError,
    {
      data: PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeamNameAlias>>,
  TError,
  { data: PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeamNameAlias>>,
    { data: PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt }
  > = (props) => {
    const { data } = props ?? {};

    return createTeamNameAlias(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeamNameAliasMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTeamNameAlias>>
>;
export type CreateTeamNameAliasMutationBody =
  PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt;
export type CreateTeamNameAliasMutationError = AxiosError<unknown>;

export const useCreateTeamNameAlias = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeamNameAlias>>,
    TError,
    {
      data: PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTeamNameAlias>>,
  TError,
  { data: PickTeamNameAliasExcludeKeyofTeamNameAliasIdOrCreatedAtOrUpdatedAt },
  TContext
> => {
  const mutationOptions = getCreateTeamNameAliasMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateTeamNameAlias = (
  pickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt: PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TeamNameAlias>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/team-name-aliases`,
    pickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt,
    options,
  );
};

export const getUpdateTeamNameAliasMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamNameAlias>>,
    TError,
    { data: PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTeamNameAlias>>,
  TError,
  { data: PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTeamNameAlias>>,
    { data: PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt }
  > = (props) => {
    const { data } = props ?? {};

    return updateTeamNameAlias(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTeamNameAliasMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTeamNameAlias>>
>;
export type UpdateTeamNameAliasMutationBody =
  PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt;
export type UpdateTeamNameAliasMutationError = AxiosError<unknown>;

export const useUpdateTeamNameAlias = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeamNameAlias>>,
    TError,
    { data: PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTeamNameAlias>>,
  TError,
  { data: PickTeamNameAliasExcludeKeyofTeamNameAliasCreatedAtOrUpdatedAt },
  TContext
> => {
  const mutationOptions = getUpdateTeamNameAliasMutationOptions(options);

  return useMutation(mutationOptions);
};

export const deleteTeamNameAlias = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TeamNameAlias>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/team-name-aliases/${id}`,
    options,
  );
};

export const getDeleteTeamNameAliasMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeamNameAlias>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTeamNameAlias>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTeamNameAlias>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTeamNameAlias(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTeamNameAliasMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTeamNameAlias>>
>;

export type DeleteTeamNameAliasMutationError = AxiosError<unknown>;

export const useDeleteTeamNameAlias = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeamNameAlias>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTeamNameAlias>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteTeamNameAliasMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getSubscriptions = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetSubscriptionsResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/subscriptions`,
    options,
  );
};

export const getGetSubscriptionsQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/subscriptions`,
  ] as const;
};

export const getGetSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubscriptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubscriptions>>
  > = ({ signal }) => getSubscriptions({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscriptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubscriptions>>
>;
export type GetSubscriptionsQueryError = AxiosError<unknown>;

export function useGetSubscriptions<
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getSubscriptions>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSubscriptions<
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getSubscriptions>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSubscriptions<
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSubscriptions<
  TData = Awaited<ReturnType<typeof getSubscriptions>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSubscriptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createStrategy = (
  createStrategyBody: CreateStrategyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CreateStrategyResponse>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/strategy/create`,
    createStrategyBody,
    options,
  );
};

export const getCreateStrategyMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStrategy>>,
    TError,
    { data: CreateStrategyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStrategy>>,
  TError,
  { data: CreateStrategyBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStrategy>>,
    { data: CreateStrategyBody }
  > = (props) => {
    const { data } = props ?? {};

    return createStrategy(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStrategyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStrategy>>
>;
export type CreateStrategyMutationBody = CreateStrategyBody;
export type CreateStrategyMutationError = AxiosError<unknown>;

export const useCreateStrategy = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStrategy>>,
    TError,
    { data: CreateStrategyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStrategy>>,
  TError,
  { data: CreateStrategyBody },
  TContext
> => {
  const mutationOptions = getCreateStrategyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const updateStrategy = (
  updateStrategyBody: UpdateStrategyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpdateStrategyResponse>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/strategy/update`,
    updateStrategyBody,
    options,
  );
};

export const getUpdateStrategyMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStrategy>>,
    TError,
    { data: UpdateStrategyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStrategy>>,
  TError,
  { data: UpdateStrategyBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStrategy>>,
    { data: UpdateStrategyBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateStrategy(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStrategyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStrategy>>
>;
export type UpdateStrategyMutationBody = UpdateStrategyBody;
export type UpdateStrategyMutationError = AxiosError<unknown>;

export const useUpdateStrategy = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStrategy>>,
    TError,
    { data: UpdateStrategyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStrategy>>,
  TError,
  { data: UpdateStrategyBody },
  TContext
> => {
  const mutationOptions = getUpdateStrategyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getStrategies = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Strategy[]>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/strategy/strategies`,
    options,
  );
};

export const getGetStrategiesQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/strategy/strategies`,
  ] as const;
};

export const getGetStrategiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getStrategies>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStrategies>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStrategiesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStrategies>>> = ({
    signal,
  }) => getStrategies({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStrategies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStrategiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStrategies>>
>;
export type GetStrategiesQueryError = AxiosError<unknown>;

export function useGetStrategies<
  TData = Awaited<ReturnType<typeof getStrategies>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStrategies>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getStrategies>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStrategies<
  TData = Awaited<ReturnType<typeof getStrategies>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStrategies>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getStrategies>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStrategies<
  TData = Awaited<ReturnType<typeof getStrategies>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStrategies>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStrategies<
  TData = Awaited<ReturnType<typeof getStrategies>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getStrategies>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStrategiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteStrategy = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Strategy>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/strategy/delete/${id}`,
    options,
  );
};

export const getDeleteStrategyMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStrategy>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStrategy>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStrategy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteStrategy(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStrategyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStrategy>>
>;

export type DeleteStrategyMutationError = AxiosError<unknown>;

export const useDeleteStrategy = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStrategy>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteStrategy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteStrategyMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getStrategy = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Strategy>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/strategy/${id}`,
    options,
  );
};

export const getGetStrategyQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/strategy/${id}`,
  ] as const;
};

export const getGetStrategyQueryOptions = <
  TData = Awaited<ReturnType<typeof getStrategy>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStrategy>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStrategyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStrategy>>> = ({
    signal,
  }) => getStrategy(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStrategy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStrategyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStrategy>>
>;
export type GetStrategyQueryError = AxiosError<unknown>;

export function useGetStrategy<
  TData = Awaited<ReturnType<typeof getStrategy>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStrategy>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStrategy>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStrategy<
  TData = Awaited<ReturnType<typeof getStrategy>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStrategy>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStrategy>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStrategy<
  TData = Awaited<ReturnType<typeof getStrategy>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStrategy>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStrategy<
  TData = Awaited<ReturnType<typeof getStrategy>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStrategy>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStrategyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStatistics = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetStatistics200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/statistics/${id}`,
    options,
  );
};

export const getGetStatisticsQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/statistics/${id}`,
  ] as const;
};

export const getGetStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStatisticsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatistics>>> = ({
    signal,
  }) => getStatistics(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatistics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatistics>>
>;
export type GetStatisticsQueryError = AxiosError<unknown>;

export function useGetStatistics<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStatistics<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStatistics<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetStatistics<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetStatisticsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSettings = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Settings>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/settings`,
    options,
  );
};

export const getGetSettingsQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/settings`,
  ] as const;
};

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({
    signal,
  }) => getSettings({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettings>>
>;
export type GetSettingsQueryError = AxiosError<unknown>;

export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getSettings>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getSettings>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSettings<
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateLeagues = (
  leagueItem: LeagueItem[],
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeagueItem[]>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/settings/update-leagues`,
    leagueItem,
    options,
  );
};

export const getUpdateLeaguesMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLeagues>>,
    TError,
    { data: LeagueItem[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLeagues>>,
  TError,
  { data: LeagueItem[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLeagues>>,
    { data: LeagueItem[] }
  > = (props) => {
    const { data } = props ?? {};

    return updateLeagues(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLeaguesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLeagues>>
>;
export type UpdateLeaguesMutationBody = LeagueItem[];
export type UpdateLeaguesMutationError = AxiosError<unknown>;

export const useUpdateLeagues = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLeagues>>,
    TError,
    { data: LeagueItem[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLeagues>>,
  TError,
  { data: LeagueItem[] },
  TContext
> => {
  const mutationOptions = getUpdateLeaguesMutationOptions(options);

  return useMutation(mutationOptions);
};

export const webhook = (
  plunkWebhookBody: PlunkWebhookBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PlunkWebhookResponse>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/plunk/webhook`,
    plunkWebhookBody,
    options,
  );
};

export const getWebhookMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhook>>,
    TError,
    { data: PlunkWebhookBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof webhook>>,
  TError,
  { data: PlunkWebhookBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof webhook>>,
    { data: PlunkWebhookBody }
  > = (props) => {
    const { data } = props ?? {};

    return webhook(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof webhook>>
>;
export type WebhookMutationBody = PlunkWebhookBody;
export type WebhookMutationError = AxiosError<unknown>;

export const useWebhook = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhook>>,
    TError,
    { data: PlunkWebhookBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof webhook>>,
  TError,
  { data: PlunkWebhookBody },
  TContext
> => {
  const mutationOptions = getWebhookMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Engagement events (delivery, open, click, bounce, complaint) from the
"Retention events — <type>" workflows. Only retention-programme emails are
on the ledger; everything else answers `ignored`. Always 200 once
authorised, whatever happened to the event.
 */
export const emailEvent = (
  plunkEmailEventBody: PlunkEmailEventBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PlunkWebhookResponse>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/plunk/email-event`,
    plunkEmailEventBody,
    options,
  );
};

export const getEmailEventMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailEvent>>,
    TError,
    { data: PlunkEmailEventBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailEvent>>,
  TError,
  { data: PlunkEmailEventBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailEvent>>,
    { data: PlunkEmailEventBody }
  > = (props) => {
    const { data } = props ?? {};

    return emailEvent(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailEvent>>
>;
export type EmailEventMutationBody = PlunkEmailEventBody;
export type EmailEventMutationError = AxiosError<unknown>;

export const useEmailEvent = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailEvent>>,
    TError,
    { data: PlunkEmailEventBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof emailEvent>>,
  TError,
  { data: PlunkEmailEventBody },
  TContext
> => {
  const mutationOptions = getEmailEventMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getPartner = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PickPartnerExcludeKeyofPartnerStripeSettings>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/partners/${id}`,
    options,
  );
};

export const getGetPartnerQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/partners/${id}`,
  ] as const;
};

export const getGetPartnerQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPartnerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartner>>> = ({
    signal,
  }) => getPartner(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPartnerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartner>>
>;
export type GetPartnerQueryError = AxiosError<unknown>;

export function useGetPartner<
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartner>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPartner<
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartner>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPartner<
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetPartner<
  TData = Awaited<ReturnType<typeof getPartner>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetPartnerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List model race results, optionally filtered by fixture ID.
Only accessible to users in the "Admin" Cognito group.
 * @summary Get model race results
 */
export const getModelRaceResults = (
  params?: GetModelRaceResultsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetModelRaceResultsResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/model-race`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetModelRaceResultsQueryKey = (
  params?: GetModelRaceResultsParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/model-race`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetModelRaceResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getModelRaceResults>>,
  TError = AxiosError<unknown>,
>(
  params?: GetModelRaceResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceResults>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetModelRaceResultsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModelRaceResults>>
  > = ({ signal }) => getModelRaceResults(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModelRaceResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetModelRaceResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModelRaceResults>>
>;
export type GetModelRaceResultsQueryError = AxiosError<unknown>;

export function useGetModelRaceResults<
  TData = Awaited<ReturnType<typeof getModelRaceResults>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetModelRaceResultsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceResults>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelRaceResults>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetModelRaceResults<
  TData = Awaited<ReturnType<typeof getModelRaceResults>>,
  TError = AxiosError<unknown>,
>(
  params?: GetModelRaceResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceResults>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelRaceResults>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModelRaceResults<
  TData = Awaited<ReturnType<typeof getModelRaceResults>>,
  TError = AxiosError<unknown>,
>(
  params?: GetModelRaceResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceResults>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get model race results
 */

export function useGetModelRaceResults<
  TData = Awaited<ReturnType<typeof getModelRaceResults>>,
  TError = AxiosError<unknown>,
>(
  params?: GetModelRaceResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceResults>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetModelRaceResultsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete all model race results for a specific fixture.
Only accessible to users in the "Admin" Cognito group.
 * @summary Delete all results for a fixture
 */
export const deleteModelRaceResultsByFixture = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteModelRaceResultsByFixtureResponse>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/model-race/${fixtureId}`,
    options,
  );
};

export const getDeleteModelRaceResultsByFixtureMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelRaceResultsByFixture>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModelRaceResultsByFixture>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModelRaceResultsByFixture>>,
    { fixtureId: string }
  > = (props) => {
    const { fixtureId } = props ?? {};

    return deleteModelRaceResultsByFixture(fixtureId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModelRaceResultsByFixtureMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModelRaceResultsByFixture>>
>;

export type DeleteModelRaceResultsByFixtureMutationError = AxiosError<unknown>;

/**
 * @summary Delete all results for a fixture
 */
export const useDeleteModelRaceResultsByFixture = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelRaceResultsByFixture>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteModelRaceResultsByFixture>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteModelRaceResultsByFixtureMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete a single model race result.
Only accessible to users in the "Admin" Cognito group.
 * @summary Delete a single result
 */
export const deleteModelRaceResult = (
  fixtureId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/model-race/${fixtureId}/${id}`,
    options,
  );
};

export const getDeleteModelRaceResultMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelRaceResult>>,
    TError,
    { fixtureId: string; id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModelRaceResult>>,
  TError,
  { fixtureId: string; id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModelRaceResult>>,
    { fixtureId: string; id: string }
  > = (props) => {
    const { fixtureId, id } = props ?? {};

    return deleteModelRaceResult(fixtureId, id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModelRaceResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModelRaceResult>>
>;

export type DeleteModelRaceResultMutationError = AxiosError<unknown>;

/**
 * @summary Delete a single result
 */
export const useDeleteModelRaceResult = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModelRaceResult>>,
    TError,
    { fixtureId: string; id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteModelRaceResult>>,
  TError,
  { fixtureId: string; id: string },
  TContext
> => {
  const mutationOptions = getDeleteModelRaceResultMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update recommendations for a model race result.
Only accessible to users in the "Admin" Cognito group.
 * @summary Update recommendations
 */
export const updateModelRaceRecommendations = (
  fixtureId: string,
  id: string,
  updateModelRaceRecommendationsBody: UpdateModelRaceRecommendationsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ModelRaceItem>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/model-race/${fixtureId}/${id}/recommendations`,
    updateModelRaceRecommendationsBody,
    options,
  );
};

export const getUpdateModelRaceRecommendationsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelRaceRecommendations>>,
    TError,
    { fixtureId: string; id: string; data: UpdateModelRaceRecommendationsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModelRaceRecommendations>>,
  TError,
  { fixtureId: string; id: string; data: UpdateModelRaceRecommendationsBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModelRaceRecommendations>>,
    { fixtureId: string; id: string; data: UpdateModelRaceRecommendationsBody }
  > = (props) => {
    const { fixtureId, id, data } = props ?? {};

    return updateModelRaceRecommendations(fixtureId, id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModelRaceRecommendationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModelRaceRecommendations>>
>;
export type UpdateModelRaceRecommendationsMutationBody =
  UpdateModelRaceRecommendationsBody;
export type UpdateModelRaceRecommendationsMutationError = AxiosError<unknown>;

/**
 * @summary Update recommendations
 */
export const useUpdateModelRaceRecommendations = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelRaceRecommendations>>,
    TError,
    { fixtureId: string; id: string; data: UpdateModelRaceRecommendationsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateModelRaceRecommendations>>,
  TError,
  { fixtureId: string; id: string; data: UpdateModelRaceRecommendationsBody },
  TContext
> => {
  const mutationOptions =
    getUpdateModelRaceRecommendationsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get aggregated performance stats for model race recommendations.
Only accessible to users in the "Admin" Cognito group.
 * @summary Get model race stats
 */
export const getModelRaceStats = (
  params?: GetModelRaceStatsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ModelRaceStatsResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/model-race/stats`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetModelRaceStatsQueryKey = (
  params?: GetModelRaceStatsParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/model-race/stats`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetModelRaceStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getModelRaceStats>>,
  TError = AxiosError<unknown>,
>(
  params?: GetModelRaceStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceStats>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetModelRaceStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModelRaceStats>>
  > = ({ signal }) => getModelRaceStats(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModelRaceStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetModelRaceStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModelRaceStats>>
>;
export type GetModelRaceStatsQueryError = AxiosError<unknown>;

export function useGetModelRaceStats<
  TData = Awaited<ReturnType<typeof getModelRaceStats>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetModelRaceStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelRaceStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetModelRaceStats<
  TData = Awaited<ReturnType<typeof getModelRaceStats>>,
  TError = AxiosError<unknown>,
>(
  params?: GetModelRaceStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelRaceStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModelRaceStats<
  TData = Awaited<ReturnType<typeof getModelRaceStats>>,
  TError = AxiosError<unknown>,
>(
  params?: GetModelRaceStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceStats>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get model race stats
 */

export function useGetModelRaceStats<
  TData = Awaited<ReturnType<typeof getModelRaceStats>>,
  TError = AxiosError<unknown>,
>(
  params?: GetModelRaceStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getModelRaceStats>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetModelRaceStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMatchAnalysis = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MatchAnalysisItem>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/analysis/${id}`,
    options,
  );
};

export const getGetMatchAnalysisQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/analysis/${id}`,
  ] as const;
};

export const getGetMatchAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getMatchAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMatchAnalysis>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMatchAnalysisQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMatchAnalysis>>
  > = ({ signal }) => getMatchAnalysis(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMatchAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMatchAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMatchAnalysis>>
>;
export type GetMatchAnalysisQueryError = AxiosError<unknown>;

export function useGetMatchAnalysis<
  TData = Awaited<ReturnType<typeof getMatchAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMatchAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMatchAnalysis>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMatchAnalysis<
  TData = Awaited<ReturnType<typeof getMatchAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMatchAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMatchAnalysis>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMatchAnalysis<
  TData = Awaited<ReturnType<typeof getMatchAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMatchAnalysis>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMatchAnalysis<
  TData = Awaited<ReturnType<typeof getMatchAnalysis>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMatchAnalysis>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMatchAnalysisQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const unlock = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UnlockMatchResponse>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/free-tier/unlock/${id}`,
    undefined,
    options,
  );
};

export const getUnlockMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlock>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlock>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlock>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return unlock(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlock>>
>;

export type UnlockMutationError = AxiosError<unknown>;

export const useUnlock = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlock>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof unlock>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getUnlockMutationOptions(options);

  return useMutation(mutationOptions);
};

export const balance = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FreeAnalysisBalanceResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/free-tier/balance`,
    options,
  );
};

export const getBalanceQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/free-tier/balance`,
  ] as const;
};

export const getBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof balance>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof balance>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalanceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balance>>> = ({
    signal,
  }) => balance({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type BalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof balance>>
>;
export type BalanceQueryError = AxiosError<unknown>;

export function useBalance<
  TData = Awaited<ReturnType<typeof balance>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof balance>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof balance>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useBalance<
  TData = Awaited<ReturnType<typeof balance>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof balance>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof balance>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useBalance<
  TData = Awaited<ReturnType<typeof balance>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof balance>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useBalance<
  TData = Awaited<ReturnType<typeof balance>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof balance>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getBalanceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const searchLeagues = (
  params: SearchLeaguesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeagueItem[]>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/football/search-leagues`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getSearchLeaguesQueryKey = (params: SearchLeaguesParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/football/search-leagues`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchLeaguesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchLeagues>>,
  TError = AxiosError<unknown>,
>(
  params: SearchLeaguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchLeagues>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchLeaguesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLeagues>>> = ({
    signal,
  }) => searchLeagues(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchLeagues>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchLeaguesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchLeagues>>
>;
export type SearchLeaguesQueryError = AxiosError<unknown>;

export function useSearchLeagues<
  TData = Awaited<ReturnType<typeof searchLeagues>>,
  TError = AxiosError<unknown>,
>(
  params: SearchLeaguesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchLeagues>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLeagues>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchLeagues<
  TData = Awaited<ReturnType<typeof searchLeagues>>,
  TError = AxiosError<unknown>,
>(
  params: SearchLeaguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchLeagues>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLeagues>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchLeagues<
  TData = Awaited<ReturnType<typeof searchLeagues>>,
  TError = AxiosError<unknown>,
>(
  params: SearchLeaguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchLeagues>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useSearchLeagues<
  TData = Awaited<ReturnType<typeof searchLeagues>>,
  TError = AxiosError<unknown>,
>(
  params: SearchLeaguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchLeagues>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchLeaguesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLeague = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeagueItem>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/football/league/${id}`,
    options,
  );
};

export const getGetLeagueQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/football/league/${id}`,
  ] as const;
};

export const getGetLeagueQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeague>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLeague>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeagueQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeague>>> = ({
    signal,
  }) => getLeague(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLeague>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetLeagueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeague>>
>;
export type GetLeagueQueryError = AxiosError<unknown>;

export function useGetLeague<
  TData = Awaited<ReturnType<typeof getLeague>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLeague>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeague>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLeague<
  TData = Awaited<ReturnType<typeof getLeague>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLeague>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeague>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLeague<
  TData = Awaited<ReturnType<typeof getLeague>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLeague>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetLeague<
  TData = Awaited<ReturnType<typeof getLeague>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLeague>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLeagueQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getOdds = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BetItem[]>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/football/odds/${fixtureId}`,
    options,
  );
};

export const getGetOddsQueryKey = (fixtureId: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/football/odds/${fixtureId}`,
  ] as const;
};

export const getGetOddsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOdds>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOdds>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOddsQueryKey(fixtureId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOdds>>> = ({
    signal,
  }) => getOdds(fixtureId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!fixtureId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOdds>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetOddsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOdds>>
>;
export type GetOddsQueryError = AxiosError<unknown>;

export function useGetOdds<
  TData = Awaited<ReturnType<typeof getOdds>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOdds>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOdds>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOdds<
  TData = Awaited<ReturnType<typeof getOdds>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOdds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOdds>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOdds<
  TData = Awaited<ReturnType<typeof getOdds>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOdds>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetOdds<
  TData = Awaited<ReturnType<typeof getOdds>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOdds>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOddsQueryOptions(fixtureId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFixture = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FixtureRecord>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/fixtures/${id}`,
    options,
  );
};

export const getGetFixtureQueryKey = (id: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/fixtures/${id}`,
  ] as const;
};

export const getGetFixtureQueryOptions = <
  TData = Awaited<ReturnType<typeof getFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixture>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFixtureQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFixture>>> = ({
    signal,
  }) => getFixture(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFixture>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFixtureQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFixture>>
>;
export type GetFixtureQueryError = AxiosError<unknown>;

export function useGetFixture<
  TData = Awaited<ReturnType<typeof getFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixture>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFixture>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFixture<
  TData = Awaited<ReturnType<typeof getFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixture>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFixture>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFixture<
  TData = Awaited<ReturnType<typeof getFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixture>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFixture<
  TData = Awaited<ReturnType<typeof getFixture>>,
  TError = AxiosError<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixture>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFixtureQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFixtures = (
  params: GetFixturesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<FixtureItem[]>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/fixtures`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetFixturesQueryKey = (params: GetFixturesParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/fixtures`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFixturesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFixtures>>,
  TError = AxiosError<unknown>,
>(
  params: GetFixturesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixtures>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFixturesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFixtures>>> = ({
    signal,
  }) => getFixtures(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFixtures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFixturesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFixtures>>
>;
export type GetFixturesQueryError = AxiosError<unknown>;

export function useGetFixtures<
  TData = Awaited<ReturnType<typeof getFixtures>>,
  TError = AxiosError<unknown>,
>(
  params: GetFixturesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixtures>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFixtures>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFixtures<
  TData = Awaited<ReturnType<typeof getFixtures>>,
  TError = AxiosError<unknown>,
>(
  params: GetFixturesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixtures>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFixtures>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFixtures<
  TData = Awaited<ReturnType<typeof getFixtures>>,
  TError = AxiosError<unknown>,
>(
  params: GetFixturesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixtures>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetFixtures<
  TData = Awaited<ReturnType<typeof getFixtures>>,
  TError = AxiosError<unknown>,
>(
  params: GetFixturesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFixtures>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFixturesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get an expert opinion by fixture ID.
Only accessible to users in the "Admin" Cognito group.
 * @summary Get expert opinion by fixture ID
 */
export const getExpertOpinion = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ExpertOpinion>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/expert-opinions/${fixtureId}`,
    options,
  );
};

export const getGetExpertOpinionQueryKey = (fixtureId: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/expert-opinions/${fixtureId}`,
  ] as const;
};

export const getGetExpertOpinionQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpertOpinion>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOpinion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExpertOpinionQueryKey(fixtureId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExpertOpinion>>
  > = ({ signal }) => getExpertOpinion(fixtureId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!fixtureId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExpertOpinion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetExpertOpinionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExpertOpinion>>
>;
export type GetExpertOpinionQueryError = AxiosError<unknown>;

export function useGetExpertOpinion<
  TData = Awaited<ReturnType<typeof getExpertOpinion>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOpinion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertOpinion>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetExpertOpinion<
  TData = Awaited<ReturnType<typeof getExpertOpinion>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOpinion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertOpinion>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetExpertOpinion<
  TData = Awaited<ReturnType<typeof getExpertOpinion>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOpinion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get expert opinion by fixture ID
 */

export function useGetExpertOpinion<
  TData = Awaited<ReturnType<typeof getExpertOpinion>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExpertOpinion>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetExpertOpinionQueryOptions(fixtureId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an expert opinion (score prediction) by extracting it from a given URL.
Only accessible to users in the "Admin" Cognito group.
 * @summary Create expert opinion from URL
 */
export const createExpertOpinionFromUrl = (
  createExpertOpinionFromUrlBody: CreateExpertOpinionFromUrlBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CreateExpertOpinionFromUrlResponse>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/expert-opinions`,
    createExpertOpinionFromUrlBody,
    options,
  );
};

export const getCreateExpertOpinionFromUrlMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExpertOpinionFromUrl>>,
    TError,
    { data: CreateExpertOpinionFromUrlBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExpertOpinionFromUrl>>,
  TError,
  { data: CreateExpertOpinionFromUrlBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExpertOpinionFromUrl>>,
    { data: CreateExpertOpinionFromUrlBody }
  > = (props) => {
    const { data } = props ?? {};

    return createExpertOpinionFromUrl(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExpertOpinionFromUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExpertOpinionFromUrl>>
>;
export type CreateExpertOpinionFromUrlMutationBody =
  CreateExpertOpinionFromUrlBody;
export type CreateExpertOpinionFromUrlMutationError = AxiosError<unknown>;

/**
 * @summary Create expert opinion from URL
 */
export const useCreateExpertOpinionFromUrl = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExpertOpinionFromUrl>>,
    TError,
    { data: CreateExpertOpinionFromUrlBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createExpertOpinionFromUrl>>,
  TError,
  { data: CreateExpertOpinionFromUrlBody },
  TContext
> => {
  const mutationOptions = getCreateExpertOpinionFromUrlMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Credits a click-through from a retention email to its send, once the
user is logged in. Always 204: the dashboard never shows an error for it,
and the answer reveals nothing about the token.
 */
export const emailLanding = (
  emailLandingBody: EmailLandingBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/engagement/email-landing`,
    emailLandingBody,
    options,
  );
};

export const getEmailLandingMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailLanding>>,
    TError,
    { data: EmailLandingBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailLanding>>,
  TError,
  { data: EmailLandingBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailLanding>>,
    { data: EmailLandingBody }
  > = (props) => {
    const { data } = props ?? {};

    return emailLanding(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailLandingMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailLanding>>
>;
export type EmailLandingMutationBody = EmailLandingBody;
export type EmailLandingMutationError = AxiosError<unknown>;

export const useEmailLanding = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailLanding>>,
    TError,
    { data: EmailLandingBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof emailLanding>>,
  TError,
  { data: EmailLandingBody },
  TContext
> => {
  const mutationOptions = getEmailLandingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * One dwell signal from the dashboard's match-view tracker (user-retention
step 09), sent only with analytics consent. Always 204: the caller learns
nothing about whether the signal was kept.
 */
export const signals = (
  engagementSignal: EngagementSignal,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/engagement/signals`,
    engagementSignal,
    options,
  );
};

export const getSignalsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signals>>,
    TError,
    { data: EngagementSignal },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signals>>,
  TError,
  { data: EngagementSignal },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signals>>,
    { data: EngagementSignal }
  > = (props) => {
    const { data } = props ?? {};

    return signals(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignalsMutationResult = NonNullable<
  Awaited<ReturnType<typeof signals>>
>;
export type SignalsMutationBody = EngagementSignal;
export type SignalsMutationError = AxiosError<unknown>;

export const useSignals = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signals>>,
    TError,
    { data: EngagementSignal },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof signals>>,
  TError,
  { data: EngagementSignal },
  TContext
> => {
  const mutationOptions = getSignalsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Whether to show the in-product email opt-in (user-retention step 33). Never throws.
 */
export const emailOptInStatus = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EmailOptInStatus200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/engagement/email-opt-in`,
    options,
  );
};

export const getEmailOptInStatusQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/engagement/email-opt-in`,
  ] as const;
};

export const getEmailOptInStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof emailOptInStatus>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof emailOptInStatus>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEmailOptInStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof emailOptInStatus>>
  > = ({ signal }) => emailOptInStatus({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof emailOptInStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type EmailOptInStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailOptInStatus>>
>;
export type EmailOptInStatusQueryError = AxiosError<unknown>;

export function useEmailOptInStatus<
  TData = Awaited<ReturnType<typeof emailOptInStatus>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof emailOptInStatus>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof emailOptInStatus>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useEmailOptInStatus<
  TData = Awaited<ReturnType<typeof emailOptInStatus>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof emailOptInStatus>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof emailOptInStatus>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useEmailOptInStatus<
  TData = Awaited<ReturnType<typeof emailOptInStatus>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof emailOptInStatus>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useEmailOptInStatus<
  TData = Awaited<ReturnType<typeof emailOptInStatus>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof emailOptInStatus>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getEmailOptInStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The answer to the opt-in card, once per user. Always 204; errors never block the dashboard.
 */
export const emailOptIn = (
  optInRequest: OptInRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/engagement/email-opt-in`,
    optInRequest,
    options,
  );
};

export const getEmailOptInMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailOptIn>>,
    TError,
    { data: OptInRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailOptIn>>,
  TError,
  { data: OptInRequest },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailOptIn>>,
    { data: OptInRequest }
  > = (props) => {
    const { data } = props ?? {};

    return emailOptIn(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailOptInMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailOptIn>>
>;
export type EmailOptInMutationBody = OptInRequest;
export type EmailOptInMutationError = AxiosError<unknown>;

export const useEmailOptIn = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailOptIn>>,
    TError,
    { data: OptInRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof emailOptIn>>,
  TError,
  { data: OptInRequest },
  TContext
> => {
  const mutationOptions = getEmailOptInMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getDailyTopPicks = (
  params?: GetDailyTopPicksParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DailyTopPicksResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/daily-top-picks/get-picks`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetDailyTopPicksQueryKey = (
  params?: GetDailyTopPicksParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/daily-top-picks/get-picks`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDailyTopPicksQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyTopPicks>>,
  TError = AxiosError<unknown>,
>(
  params?: GetDailyTopPicksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyTopPicksQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyTopPicks>>
  > = ({ signal }) => getDailyTopPicks(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyTopPicks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDailyTopPicksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyTopPicks>>
>;
export type GetDailyTopPicksQueryError = AxiosError<unknown>;

export function useGetDailyTopPicks<
  TData = Awaited<ReturnType<typeof getDailyTopPicks>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetDailyTopPicksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyTopPicks>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDailyTopPicks<
  TData = Awaited<ReturnType<typeof getDailyTopPicks>>,
  TError = AxiosError<unknown>,
>(
  params?: GetDailyTopPicksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyTopPicks>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDailyTopPicks<
  TData = Awaited<ReturnType<typeof getDailyTopPicks>>,
  TError = AxiosError<unknown>,
>(
  params?: GetDailyTopPicksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDailyTopPicks<
  TData = Awaited<ReturnType<typeof getDailyTopPicks>>,
  TError = AxiosError<unknown>,
>(
  params?: GetDailyTopPicksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicks>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDailyTopPicksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDailyTopPicksSummary = (
  params?: GetDailyTopPicksSummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DailyTopPicksPerformanceResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/daily-top-picks/summary`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetDailyTopPicksSummaryQueryKey = (
  params?: GetDailyTopPicksSummaryParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/daily-top-picks/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDailyTopPicksSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
  TError = AxiosError<unknown>,
>(
  params?: GetDailyTopPicksSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyTopPicksSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailyTopPicksSummary>>
  > = ({ signal }) =>
    getDailyTopPicksSummary(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDailyTopPicksSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyTopPicksSummary>>
>;
export type GetDailyTopPicksSummaryQueryError = AxiosError<unknown>;

export function useGetDailyTopPicksSummary<
  TData = Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetDailyTopPicksSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDailyTopPicksSummary<
  TData = Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
  TError = AxiosError<unknown>,
>(
  params?: GetDailyTopPicksSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDailyTopPicksSummary<
  TData = Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
  TError = AxiosError<unknown>,
>(
  params?: GetDailyTopPicksSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDailyTopPicksSummary<
  TData = Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
  TError = AxiosError<unknown>,
>(
  params?: GetDailyTopPicksSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDailyTopPicksSummary>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDailyTopPicksSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getBestFilter = (
  params?: GetBestFilterParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BestDailyTopPicksFilterResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/daily-top-picks/best-filter`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetBestFilterQueryKey = (params?: GetBestFilterParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/daily-top-picks/best-filter`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBestFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getBestFilter>>,
  TError = AxiosError<unknown>,
>(
  params?: GetBestFilterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBestFilter>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBestFilterQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBestFilter>>> = ({
    signal,
  }) => getBestFilter(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBestFilter>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetBestFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBestFilter>>
>;
export type GetBestFilterQueryError = AxiosError<unknown>;

export function useGetBestFilter<
  TData = Awaited<ReturnType<typeof getBestFilter>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetBestFilterParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBestFilter>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBestFilter>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBestFilter<
  TData = Awaited<ReturnType<typeof getBestFilter>>,
  TError = AxiosError<unknown>,
>(
  params?: GetBestFilterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBestFilter>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBestFilter>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBestFilter<
  TData = Awaited<ReturnType<typeof getBestFilter>>,
  TError = AxiosError<unknown>,
>(
  params?: GetBestFilterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBestFilter>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetBestFilter<
  TData = Awaited<ReturnType<typeof getBestFilter>>,
  TError = AxiosError<unknown>,
>(
  params?: GetBestFilterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBestFilter>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetBestFilterQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCurrencies = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Currency[]>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/currency`,
    options,
  );
};

export const getGetCurrenciesQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/currency`,
  ] as const;
};

export const getGetCurrenciesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrencies>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrencies>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrenciesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrencies>>> = ({
    signal,
  }) => getCurrencies({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrencies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCurrenciesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrencies>>
>;
export type GetCurrenciesQueryError = AxiosError<unknown>;

export function useGetCurrencies<
  TData = Awaited<ReturnType<typeof getCurrencies>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrencies>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getCurrencies>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCurrencies<
  TData = Awaited<ReturnType<typeof getCurrencies>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrencies>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getCurrencies>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCurrencies<
  TData = Awaited<ReturnType<typeof getCurrencies>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrencies>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetCurrencies<
  TData = Awaited<ReturnType<typeof getCurrencies>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrencies>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCurrenciesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const contact = (
  contactBody: ContactBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ContactResponse>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/communications/contact`,
    contactBody,
    options,
  );
};

export const getContactMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contact>>,
    TError,
    { data: ContactBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof contact>>,
  TError,
  { data: ContactBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof contact>>,
    { data: ContactBody }
  > = (props) => {
    const { data } = props ?? {};

    return contact(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof contact>>
>;
export type ContactMutationBody = ContactBody;
export type ContactMutationError = AxiosError<unknown>;

export const useContact = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof contact>>,
    TError,
    { data: ContactBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof contact>>,
  TError,
  { data: ContactBody },
  TContext
> => {
  const mutationOptions = getContactMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get authentication performance metrics and cache statistics
 * @summary Retrieve authentication performance data
 */
export const getAuthMetrics = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetAuthMetrics200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/auth-metrics`,
    options,
  );
};

export const getGetAuthMetricsQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/auth-metrics`,
  ] as const;
};

export const getGetAuthMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthMetrics>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthMetricsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMetrics>>> = ({
    signal,
  }) => getAuthMetrics({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAuthMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthMetrics>>
>;
export type GetAuthMetricsQueryError = AxiosError<unknown>;

export function useGetAuthMetrics<
  TData = Awaited<ReturnType<typeof getAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthMetrics>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAuthMetrics>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAuthMetrics<
  TData = Awaited<ReturnType<typeof getAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthMetrics>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAuthMetrics>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAuthMetrics<
  TData = Awaited<ReturnType<typeof getAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthMetrics>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Retrieve authentication performance data
 */

export function useGetAuthMetrics<
  TData = Awaited<ReturnType<typeof getAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthMetrics>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAuthMetricsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reset authentication metrics (useful for testing)
 * @summary Reset all authentication metrics
 */
export const resetAuthMetrics = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ResetAuthMetrics200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/auth-metrics/reset`,
    options,
  );
};

export const getResetAuthMetricsQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/auth-metrics/reset`,
  ] as const;
};

export const getResetAuthMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof resetAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof resetAuthMetrics>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getResetAuthMetricsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof resetAuthMetrics>>
  > = ({ signal }) => resetAuthMetrics({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof resetAuthMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ResetAuthMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof resetAuthMetrics>>
>;
export type ResetAuthMetricsQueryError = AxiosError<unknown>;

export function useResetAuthMetrics<
  TData = Awaited<ReturnType<typeof resetAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof resetAuthMetrics>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof resetAuthMetrics>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useResetAuthMetrics<
  TData = Awaited<ReturnType<typeof resetAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof resetAuthMetrics>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof resetAuthMetrics>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useResetAuthMetrics<
  TData = Awaited<ReturnType<typeof resetAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof resetAuthMetrics>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Reset all authentication metrics
 */

export function useResetAuthMetrics<
  TData = Awaited<ReturnType<typeof resetAuthMetrics>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof resetAuthMetrics>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getResetAuthMetricsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Clear authentication caches (useful for testing)
 * @summary Clear all authentication caches
 */
export const clearAuthCaches = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ClearAuthCaches200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/auth-metrics/clear-cache`,
    options,
  );
};

export const getClearAuthCachesQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/auth-metrics/clear-cache`,
  ] as const;
};

export const getClearAuthCachesQueryOptions = <
  TData = Awaited<ReturnType<typeof clearAuthCaches>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof clearAuthCaches>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getClearAuthCachesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof clearAuthCaches>>> = ({
    signal,
  }) => clearAuthCaches({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof clearAuthCaches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ClearAuthCachesQueryResult = NonNullable<
  Awaited<ReturnType<typeof clearAuthCaches>>
>;
export type ClearAuthCachesQueryError = AxiosError<unknown>;

export function useClearAuthCaches<
  TData = Awaited<ReturnType<typeof clearAuthCaches>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof clearAuthCaches>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof clearAuthCaches>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useClearAuthCaches<
  TData = Awaited<ReturnType<typeof clearAuthCaches>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof clearAuthCaches>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof clearAuthCaches>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useClearAuthCaches<
  TData = Awaited<ReturnType<typeof clearAuthCaches>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof clearAuthCaches>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Clear all authentication caches
 */

export function useClearAuthCaches<
  TData = Awaited<ReturnType<typeof clearAuthCaches>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof clearAuthCaches>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getClearAuthCachesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List published articles with optional filtering by league and date.
 */
export const getArticles = (
  params?: GetArticlesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ArticlesListResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/articles`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetArticlesQueryKey = (params?: GetArticlesParams) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/articles`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetArticlesQueryOptions = <
  TData = Awaited<ReturnType<typeof getArticles>>,
  TError = AxiosError<unknown>,
>(
  params?: GetArticlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getArticles>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetArticlesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getArticles>>> = ({
    signal,
  }) => getArticles(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getArticles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetArticlesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getArticles>>
>;
export type GetArticlesQueryError = AxiosError<unknown>;

export function useGetArticles<
  TData = Awaited<ReturnType<typeof getArticles>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetArticlesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getArticles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticles>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetArticles<
  TData = Awaited<ReturnType<typeof getArticles>>,
  TError = AxiosError<unknown>,
>(
  params?: GetArticlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getArticles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticles>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetArticles<
  TData = Awaited<ReturnType<typeof getArticles>>,
  TError = AxiosError<unknown>,
>(
  params?: GetArticlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getArticles>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetArticles<
  TData = Awaited<ReturnType<typeof getArticles>>,
  TError = AxiosError<unknown>,
>(
  params?: GetArticlesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getArticles>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetArticlesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a published article by its URL slug.
 */
export const getArticleBySlug = (
  slug: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetArticleBySlug200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/articles/slug/${slug}`,
    options,
  );
};

export const getGetArticleBySlugQueryKey = (slug: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/articles/slug/${slug}`,
  ] as const;
};

export const getGetArticleBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getArticleBySlug>>,
  TError = AxiosError<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleBySlug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetArticleBySlugQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getArticleBySlug>>
  > = ({ signal }) => getArticleBySlug(slug, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getArticleBySlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetArticleBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getArticleBySlug>>
>;
export type GetArticleBySlugQueryError = AxiosError<unknown>;

export function useGetArticleBySlug<
  TData = Awaited<ReturnType<typeof getArticleBySlug>>,
  TError = AxiosError<unknown>,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleBySlug>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetArticleBySlug<
  TData = Awaited<ReturnType<typeof getArticleBySlug>>,
  TError = AxiosError<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleBySlug>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetArticleBySlug<
  TData = Awaited<ReturnType<typeof getArticleBySlug>>,
  TError = AxiosError<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleBySlug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetArticleBySlug<
  TData = Awaited<ReturnType<typeof getArticleBySlug>>,
  TError = AxiosError<unknown>,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleBySlug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetArticleBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get an article by fixture ID (returns latest published version).
 */
export const getArticleByFixture = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetArticleByFixture200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/articles/fixture/${fixtureId}`,
    options,
  );
};

export const getGetArticleByFixtureQueryKey = (fixtureId: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/articles/fixture/${fixtureId}`,
  ] as const;
};

export const getGetArticleByFixtureQueryOptions = <
  TData = Awaited<ReturnType<typeof getArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetArticleByFixtureQueryKey(fixtureId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getArticleByFixture>>
  > = ({ signal }) =>
    getArticleByFixture(fixtureId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!fixtureId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getArticleByFixture>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetArticleByFixtureQueryResult = NonNullable<
  Awaited<ReturnType<typeof getArticleByFixture>>
>;
export type GetArticleByFixtureQueryError = AxiosError<unknown>;

export function useGetArticleByFixture<
  TData = Awaited<ReturnType<typeof getArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleByFixture>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleByFixture>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetArticleByFixture<
  TData = Awaited<ReturnType<typeof getArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleByFixture>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleByFixture>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetArticleByFixture<
  TData = Awaited<ReturnType<typeof getArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetArticleByFixture<
  TData = Awaited<ReturnType<typeof getArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArticleByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetArticleByFixtureQueryOptions(fixtureId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Trigger article generation for a fixture via Step Function.
 */
export const generateArticle = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenerateArticle202>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/articles/generate/${fixtureId}`,
    undefined,
    options,
  );
};

export const getGenerateArticleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateArticle>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateArticle>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateArticle>>,
    { fixtureId: string }
  > = (props) => {
    const { fixtureId } = props ?? {};

    return generateArticle(fixtureId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateArticleMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateArticle>>
>;

export type GenerateArticleMutationError = AxiosError<unknown>;

export const useGenerateArticle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateArticle>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateArticle>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const mutationOptions = getGenerateArticleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Check the status of an article generation pipeline.
The frontend should poll this endpoint after triggering generation.
 */
export const getGenerationStatus = (
  fixtureId: string,
  params: GetGenerationStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ArticleGenerationStatusResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/articles/generate/${fixtureId}/status`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetGenerationStatusQueryKey = (
  fixtureId: string,
  params: GetGenerationStatusParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/articles/generate/${fixtureId}/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetGenerationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getGenerationStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  params: GetGenerationStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGenerationStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGenerationStatusQueryKey(fixtureId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGenerationStatus>>
  > = ({ signal }) =>
    getGenerationStatus(fixtureId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!fixtureId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGenerationStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetGenerationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGenerationStatus>>
>;
export type GetGenerationStatusQueryError = AxiosError<unknown>;

export function useGetGenerationStatus<
  TData = Awaited<ReturnType<typeof getGenerationStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  params: GetGenerationStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGenerationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGenerationStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetGenerationStatus<
  TData = Awaited<ReturnType<typeof getGenerationStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  params: GetGenerationStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGenerationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGenerationStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetGenerationStatus<
  TData = Awaited<ReturnType<typeof getGenerationStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  params: GetGenerationStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGenerationStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetGenerationStatus<
  TData = Awaited<ReturnType<typeof getGenerationStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  params: GetGenerationStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGenerationStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetGenerationStatusQueryOptions(
    fixtureId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List draft articles awaiting review.
 */
export const getDraftArticles = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ArticleItem[]>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/articles/admin/drafts`,
    options,
  );
};

export const getGetDraftArticlesQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/articles/admin/drafts`,
  ] as const;
};

export const getGetDraftArticlesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDraftArticles>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDraftArticles>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDraftArticlesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDraftArticles>>
  > = ({ signal }) => getDraftArticles({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDraftArticles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDraftArticlesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDraftArticles>>
>;
export type GetDraftArticlesQueryError = AxiosError<unknown>;

export function useGetDraftArticles<
  TData = Awaited<ReturnType<typeof getDraftArticles>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDraftArticles>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getDraftArticles>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDraftArticles<
  TData = Awaited<ReturnType<typeof getDraftArticles>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDraftArticles>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getDraftArticles>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDraftArticles<
  TData = Awaited<ReturnType<typeof getDraftArticles>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDraftArticles>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetDraftArticles<
  TData = Awaited<ReturnType<typeof getDraftArticles>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDraftArticles>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetDraftArticlesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get an article by fixture ID (admin access - returns any status).
 */
export const getAdminArticleByFixture = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetAdminArticleByFixture200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/articles/admin/fixture/${fixtureId}`,
    options,
  );
};

export const getGetAdminArticleByFixtureQueryKey = (fixtureId: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/articles/admin/fixture/${fixtureId}`,
  ] as const;
};

export const getGetAdminArticleByFixtureQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminArticleByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminArticleByFixtureQueryKey(fixtureId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminArticleByFixture>>
  > = ({ signal }) =>
    getAdminArticleByFixture(fixtureId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!fixtureId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminArticleByFixture>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAdminArticleByFixtureQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminArticleByFixture>>
>;
export type GetAdminArticleByFixtureQueryError = AxiosError<unknown>;

export function useGetAdminArticleByFixture<
  TData = Awaited<ReturnType<typeof getAdminArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminArticleByFixture>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminArticleByFixture>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAdminArticleByFixture<
  TData = Awaited<ReturnType<typeof getAdminArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminArticleByFixture>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminArticleByFixture>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminArticleByFixture<
  TData = Awaited<ReturnType<typeof getAdminArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminArticleByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAdminArticleByFixture<
  TData = Awaited<ReturnType<typeof getAdminArticleByFixture>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAdminArticleByFixture>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAdminArticleByFixtureQueryOptions(
    fixtureId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Publish a draft article.
 */
export const publishArticle = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ArticleItem>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/articles/${fixtureId}/publish`,
    undefined,
    options,
  );
};

export const getPublishArticleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishArticle>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishArticle>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishArticle>>,
    { fixtureId: string }
  > = (props) => {
    const { fixtureId } = props ?? {};

    return publishArticle(fixtureId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishArticleMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishArticle>>
>;

export type PublishArticleMutationError = AxiosError<unknown>;

export const usePublishArticle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishArticle>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof publishArticle>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const mutationOptions = getPublishArticleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Archive a published article.
 */
export const archiveArticle = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ArchiveArticle200>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/articles/${fixtureId}/archive`,
    undefined,
    options,
  );
};

export const getArchiveArticleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveArticle>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveArticle>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveArticle>>,
    { fixtureId: string }
  > = (props) => {
    const { fixtureId } = props ?? {};

    return archiveArticle(fixtureId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveArticleMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveArticle>>
>;

export type ArchiveArticleMutationError = AxiosError<unknown>;

export const useArchiveArticle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveArticle>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveArticle>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const mutationOptions = getArchiveArticleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update article content (editorial edits before publishing).
 */
export const updateArticle = (
  fixtureId: string,
  updateArticleBody: UpdateArticleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ArticleItem>> => {
  return axios.put(
    `https://api.football-genie.com/o1-typescript-service/articles/${fixtureId}`,
    updateArticleBody,
    options,
  );
};

export const getUpdateArticleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateArticle>>,
    TError,
    { fixtureId: string; data: UpdateArticleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateArticle>>,
  TError,
  { fixtureId: string; data: UpdateArticleBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateArticle>>,
    { fixtureId: string; data: UpdateArticleBody }
  > = (props) => {
    const { fixtureId, data } = props ?? {};

    return updateArticle(fixtureId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateArticleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateArticle>>
>;
export type UpdateArticleMutationBody = UpdateArticleBody;
export type UpdateArticleMutationError = AxiosError<unknown>;

export const useUpdateArticle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateArticle>>,
    TError,
    { fixtureId: string; data: UpdateArticleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateArticle>>,
  TError,
  { fixtureId: string; data: UpdateArticleBody },
  TContext
> => {
  const mutationOptions = getUpdateArticleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete an article.
 */
export const deleteArticle = (
  fixtureId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/articles/${fixtureId}`,
    options,
  );
};

export const getDeleteArticleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteArticle>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteArticle>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteArticle>>,
    { fixtureId: string }
  > = (props) => {
    const { fixtureId } = props ?? {};

    return deleteArticle(fixtureId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteArticleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteArticle>>
>;

export type DeleteArticleMutationError = AxiosError<unknown>;

export const useDeleteArticle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteArticle>>,
    TError,
    { fixtureId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteArticle>>,
  TError,
  { fixtureId: string },
  TContext
> => {
  const mutationOptions = getDeleteArticleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Start the CreateTipsPipeline Step Functions state machine for a fixture
 * @summary Trigger the tips pipeline for a fixture
 */
export const triggerFixturePipeline = (
  fixtureId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TriggerPipelineResponse>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/admin/pipeline/fixtures/${fixtureId}/trigger`,
    undefined,
    options,
  );
};

export const getTriggerFixturePipelineMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerFixturePipeline>>,
    TError,
    { fixtureId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerFixturePipeline>>,
  TError,
  { fixtureId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerFixturePipeline>>,
    { fixtureId: number }
  > = (props) => {
    const { fixtureId } = props ?? {};

    return triggerFixturePipeline(fixtureId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerFixturePipelineMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerFixturePipeline>>
>;

export type TriggerFixturePipelineMutationError = AxiosError<unknown>;

/**
 * @summary Trigger the tips pipeline for a fixture
 */
export const useTriggerFixturePipeline = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerFixturePipeline>>,
    TError,
    { fixtureId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerFixturePipeline>>,
  TError,
  { fixtureId: number },
  TContext
> => {
  const mutationOptions = getTriggerFixturePipelineMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get the current execution status of the tips pipeline for a fixture
 * @summary Get pipeline execution status for a fixture
 */
export const getFixturePipelineStatus = (
  fixtureId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PipelineStatusResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/pipeline/fixtures/${fixtureId}/status`,
    options,
  );
};

export const getGetFixturePipelineStatusQueryKey = (fixtureId: number) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/pipeline/fixtures/${fixtureId}/status`,
  ] as const;
};

export const getGetFixturePipelineStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getFixturePipelineStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFixturePipelineStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFixturePipelineStatusQueryKey(fixtureId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFixturePipelineStatus>>
  > = ({ signal }) =>
    getFixturePipelineStatus(fixtureId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!fixtureId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFixturePipelineStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetFixturePipelineStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFixturePipelineStatus>>
>;
export type GetFixturePipelineStatusQueryError = AxiosError<unknown>;

export function useGetFixturePipelineStatus<
  TData = Awaited<ReturnType<typeof getFixturePipelineStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFixturePipelineStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFixturePipelineStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFixturePipelineStatus<
  TData = Awaited<ReturnType<typeof getFixturePipelineStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFixturePipelineStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFixturePipelineStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFixturePipelineStatus<
  TData = Awaited<ReturnType<typeof getFixturePipelineStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFixturePipelineStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get pipeline execution status for a fixture
 */

export function useGetFixturePipelineStatus<
  TData = Awaited<ReturnType<typeof getFixturePipelineStatus>>,
  TError = AxiosError<unknown>,
>(
  fixtureId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFixturePipelineStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetFixturePipelineStatusQueryOptions(
    fixtureId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get current admin user information and their partner details
 * @summary Get admin user and partner information
 */
export const getMe = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AdminMeResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/me`,
    options,
  );
};

export const getGetMeQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/me`,
  ] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = AxiosError<unknown>;

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getMe>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getMe>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get admin user and partner information
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get users from partner's Cognito User Pool
 * @summary Get partner's user pool users with token-based pagination and search
 */
export const getUserPoolUsers = (
  params?: GetUserPoolUsersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetUserPoolUsersResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetUserPoolUsersQueryKey = (
  params?: GetUserPoolUsersParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserPoolUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPoolUsers>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserPoolUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPoolUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserPoolUsersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPoolUsers>>
  > = ({ signal }) => getUserPoolUsers(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPoolUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserPoolUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPoolUsers>>
>;
export type GetUserPoolUsersQueryError = AxiosError<unknown>;

export function useGetUserPoolUsers<
  TData = Awaited<ReturnType<typeof getUserPoolUsers>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | GetUserPoolUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPoolUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPoolUsers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserPoolUsers<
  TData = Awaited<ReturnType<typeof getUserPoolUsers>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserPoolUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPoolUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPoolUsers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserPoolUsers<
  TData = Awaited<ReturnType<typeof getUserPoolUsers>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserPoolUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPoolUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get partner's user pool users with token-based pagination and search
 */

export function useGetUserPoolUsers<
  TData = Awaited<ReturnType<typeof getUserPoolUsers>>,
  TError = AxiosError<unknown>,
>(
  params?: GetUserPoolUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserPoolUsers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserPoolUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get main statistics for partner's Cognito User Pool
 * @summary Get user pool stats (total, subscribed, email vs social signups)
 */
export const getUserPoolStats = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetUserPoolStatsResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users/stats`,
    options,
  );
};

export const getGetUserPoolStatsQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users/stats`,
  ] as const;
};

export const getGetUserPoolStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserPoolStats>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserPoolStats>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserPoolStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserPoolStats>>
  > = ({ signal }) => getUserPoolStats({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserPoolStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserPoolStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserPoolStats>>
>;
export type GetUserPoolStatsQueryError = AxiosError<unknown>;

export function useGetUserPoolStats<
  TData = Awaited<ReturnType<typeof getUserPoolStats>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserPoolStats>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserPoolStats>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserPoolStats<
  TData = Awaited<ReturnType<typeof getUserPoolStats>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserPoolStats>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserPoolStats>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserPoolStats<
  TData = Awaited<ReturnType<typeof getUserPoolStats>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserPoolStats>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user pool stats (total, subscribed, email vs social signups)
 */

export function useGetUserPoolStats<
  TData = Awaited<ReturnType<typeof getUserPoolStats>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getUserPoolStats>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserPoolStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get additional details for a specific user
 * @summary Get comprehensive user details from all related tables
 */
export const getUserDetails = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AdminUserDetailsResponse>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users/${userId}`,
    options,
  );
};

export const getGetUserDetailsQueryKey = (userId: string) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users/${userId}`,
  ] as const;
};

export const getGetUserDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = AxiosError<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserDetailsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDetails>>> = ({
    signal,
  }) => getUserDetails(userId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserDetails>>
>;
export type GetUserDetailsQueryError = AxiosError<unknown>;

export function useGetUserDetails<
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = AxiosError<unknown>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserDetails>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserDetails<
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = AxiosError<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserDetails>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserDetails<
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = AxiosError<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get comprehensive user details from all related tables
 */

export function useGetUserDetails<
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = AxiosError<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserDetailsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete a user from the partner's user pool
 * @summary Delete a user and all associated data from the partner's user pool
 */
export const deletePartnerUser = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(
    `https://api.football-genie.com/o1-typescript-service/admin/users/${userId}`,
    options,
  );
};

export const getDeletePartnerUserMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePartnerUser>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePartnerUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePartnerUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return deletePartnerUser(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePartnerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePartnerUser>>
>;

export type DeletePartnerUserMutationError = AxiosError<unknown>;

/**
 * @summary Delete a user and all associated data from the partner's user pool
 */
export const useDeletePartnerUser = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePartnerUser>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePartnerUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getDeletePartnerUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sign out a user from the partner's user pool (invalidates all tokens)
 * @summary Sign out user from Cognito user pool
 */
export const signOutPartnerUser = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/admin/users/${userId}/sign-out`,
    undefined,
    options,
  );
};

export const getSignOutPartnerUserMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signOutPartnerUser>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signOutPartnerUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signOutPartnerUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return signOutPartnerUser(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignOutPartnerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof signOutPartnerUser>>
>;

export type SignOutPartnerUserMutationError = AxiosError<unknown>;

/**
 * @summary Sign out user from Cognito user pool
 */
export const useSignOutPartnerUser = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signOutPartnerUser>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof signOutPartnerUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getSignOutPartnerUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Disable a user in the partner's user pool
 * @summary Disable user access in Cognito user pool
 */
export const disablePartnerUser = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/admin/users/${userId}/disable`,
    undefined,
    options,
  );
};

export const getDisablePartnerUserMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disablePartnerUser>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disablePartnerUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disablePartnerUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return disablePartnerUser(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisablePartnerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof disablePartnerUser>>
>;

export type DisablePartnerUserMutationError = AxiosError<unknown>;

/**
 * @summary Disable user access in Cognito user pool
 */
export const useDisablePartnerUser = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disablePartnerUser>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof disablePartnerUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getDisablePartnerUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Enable a user in the partner's user pool
 * @summary Enable user access in Cognito user pool
 */
export const enablePartnerUser = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `https://api.football-genie.com/o1-typescript-service/admin/users/${userId}/enable`,
    undefined,
    options,
  );
};

export const getEnablePartnerUserMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enablePartnerUser>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enablePartnerUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enablePartnerUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return enablePartnerUser(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnablePartnerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof enablePartnerUser>>
>;

export type EnablePartnerUserMutationError = AxiosError<unknown>;

/**
 * @summary Enable user access in Cognito user pool
 */
export const useEnablePartnerUser = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enablePartnerUser>>,
    TError,
    { userId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof enablePartnerUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getEnablePartnerUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Check status of a previously started CSV export
 * @summary Check export status
 */
export const getExportUsersCsvStatus = (
  params: GetExportUsersCsvStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetExportUsersCsvStatus200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/csv/status`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetExportUsersCsvStatusQueryKey = (
  params: GetExportUsersCsvStatusParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/csv/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetExportUsersCsvStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersCsvStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExportUsersCsvStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExportUsersCsvStatus>>
  > = ({ signal }) =>
    getExportUsersCsvStatus(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetExportUsersCsvStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExportUsersCsvStatus>>
>;
export type GetExportUsersCsvStatusQueryError = AxiosError<unknown>;

export function useGetExportUsersCsvStatus<
  TData = Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersCsvStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetExportUsersCsvStatus<
  TData = Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersCsvStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetExportUsersCsvStatus<
  TData = Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersCsvStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Check export status
 */

export function useGetExportUsersCsvStatus<
  TData = Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersCsvStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersCsvStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetExportUsersCsvStatusQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export all users with full details in CSV format asynchronously
 * @summary Start export users CSV (async)
 */
export const startExportUsersCsv = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StartExportUsersCsv200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/csv/start`,
    options,
  );
};

export const getStartExportUsersCsvQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/csv/start`,
  ] as const;
};

export const getStartExportUsersCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof startExportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersCsv>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStartExportUsersCsvQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof startExportUsersCsv>>
  > = ({ signal }) => startExportUsersCsv({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof startExportUsersCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StartExportUsersCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof startExportUsersCsv>>
>;
export type StartExportUsersCsvQueryError = AxiosError<unknown>;

export function useStartExportUsersCsv<
  TData = Awaited<ReturnType<typeof startExportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersCsv>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof startExportUsersCsv>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStartExportUsersCsv<
  TData = Awaited<ReturnType<typeof startExportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersCsv>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof startExportUsersCsv>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStartExportUsersCsv<
  TData = Awaited<ReturnType<typeof startExportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersCsv>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Start export users CSV (async)
 */

export function useStartExportUsersCsv<
  TData = Awaited<ReturnType<typeof startExportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersCsv>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStartExportUsersCsvQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export all users with full details in CSV format
 * @summary Export users CSV
 */
export const exportUsersCsv = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/csv`,
    options,
  );
};

export const getExportUsersCsvQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/csv`,
  ] as const;
};

export const getExportUsersCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof exportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersCsv>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportUsersCsvQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportUsersCsv>>> = ({
    signal,
  }) => exportUsersCsv({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportUsersCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ExportUsersCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportUsersCsv>>
>;
export type ExportUsersCsvQueryError = AxiosError<unknown>;

export function useExportUsersCsv<
  TData = Awaited<ReturnType<typeof exportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersCsv>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof exportUsersCsv>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportUsersCsv<
  TData = Awaited<ReturnType<typeof exportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersCsv>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof exportUsersCsv>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportUsersCsv<
  TData = Awaited<ReturnType<typeof exportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersCsv>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export users CSV
 */

export function useExportUsersCsv<
  TData = Awaited<ReturnType<typeof exportUsersCsv>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersCsv>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getExportUsersCsvQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export all users with full details in JSON format
 * @summary Export users JSON
 */
export const exportUsersJson = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/json`,
    options,
  );
};

export const getExportUsersJsonQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/json`,
  ] as const;
};

export const getExportUsersJsonQueryOptions = <
  TData = Awaited<ReturnType<typeof exportUsersJson>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersJson>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportUsersJsonQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportUsersJson>>> = ({
    signal,
  }) => exportUsersJson({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportUsersJson>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ExportUsersJsonQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportUsersJson>>
>;
export type ExportUsersJsonQueryError = AxiosError<unknown>;

export function useExportUsersJson<
  TData = Awaited<ReturnType<typeof exportUsersJson>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersJson>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof exportUsersJson>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportUsersJson<
  TData = Awaited<ReturnType<typeof exportUsersJson>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersJson>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof exportUsersJson>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportUsersJson<
  TData = Awaited<ReturnType<typeof exportUsersJson>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersJson>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export users JSON
 */

export function useExportUsersJson<
  TData = Awaited<ReturnType<typeof exportUsersJson>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof exportUsersJson>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getExportUsersJsonQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Check status of a previously started JSON export
 * @summary Check JSON export status
 */
export const getExportUsersJsonStatus = (
  params: GetExportUsersJsonStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GetExportUsersJsonStatus200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/json/status`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetExportUsersJsonStatusQueryKey = (
  params: GetExportUsersJsonStatusParams,
) => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/json/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetExportUsersJsonStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersJsonStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExportUsersJsonStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExportUsersJsonStatus>>
  > = ({ signal }) =>
    getExportUsersJsonStatus(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetExportUsersJsonStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExportUsersJsonStatus>>
>;
export type GetExportUsersJsonStatusQueryError = AxiosError<unknown>;

export function useGetExportUsersJsonStatus<
  TData = Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersJsonStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetExportUsersJsonStatus<
  TData = Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersJsonStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
          TError,
          TData
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetExportUsersJsonStatus<
  TData = Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersJsonStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Check JSON export status
 */

export function useGetExportUsersJsonStatus<
  TData = Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
  TError = AxiosError<unknown>,
>(
  params: GetExportUsersJsonStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExportUsersJsonStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetExportUsersJsonStatusQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export all users with full details in JSON format asynchronously
 * @summary Start export users JSON (async)
 */
export const startExportUsersJson = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StartExportUsersJson200>> => {
  return axios.get(
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/json/start`,
    options,
  );
};

export const getStartExportUsersJsonQueryKey = () => {
  return [
    `https://api.football-genie.com/o1-typescript-service/admin/users/export/json/start`,
  ] as const;
};

export const getStartExportUsersJsonQueryOptions = <
  TData = Awaited<ReturnType<typeof startExportUsersJson>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersJson>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStartExportUsersJsonQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof startExportUsersJson>>
  > = ({ signal }) => startExportUsersJson({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof startExportUsersJson>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StartExportUsersJsonQueryResult = NonNullable<
  Awaited<ReturnType<typeof startExportUsersJson>>
>;
export type StartExportUsersJsonQueryError = AxiosError<unknown>;

export function useStartExportUsersJson<
  TData = Awaited<ReturnType<typeof startExportUsersJson>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersJson>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof startExportUsersJson>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useStartExportUsersJson<
  TData = Awaited<ReturnType<typeof startExportUsersJson>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersJson>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof startExportUsersJson>>,
        TError,
        TData
      >,
      "initialData"
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStartExportUsersJson<
  TData = Awaited<ReturnType<typeof startExportUsersJson>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersJson>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Start export users JSON (async)
 */

export function useStartExportUsersJson<
  TData = Awaited<ReturnType<typeof startExportUsersJson>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof startExportUsersJson>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStartExportUsersJsonQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
